export default {
  'pages.layouts.userLayout.title': '',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Enter password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.emailLogin.tab': 'Email Login',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneSendCode': 'Send Code',
  'pages.login.phoneCodeSent': 'Verification code sent to your phone',
  'pages.login.phoneCodeSentTo': 'Verification code sent to',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',

  // Login page
  'pages.login.email.placeholder': 'Enter your email',
  'pages.login.email.required': 'Please enter your email!',
  'pages.login.email.invalid': 'Invalid email format!',
  'pages.login.noAccount': "Don't have an account?",
  'pages.login.register': 'Register now',
  'pages.login.googleLogin': 'Sign in with Google',
  'pages.login.googleSuccess': 'Google login successful',
  'pages.login.googleFailed': 'Google login failed',
  'pages.login.codeSent': 'Verification code has been sent to your email',
  'pages.login.codeResent': 'Verification code resent',
  'pages.login.sendCodeFailed': 'Failed to send verification code',
  'pages.login.requestFailed': 'Login request failed, please try again',
  'pages.login.verifyFailed': 'Verification failed, please try again',
  'pages.login.verify': 'Verify',
  'pages.login.codeSentTo': 'Verification code sent to',
  'pages.login.resendAfter': 'Resend in {seconds}s',
  'pages.login.resend': 'Resend',
  'pages.login.captcha.length': 'Code must be 6 digits',
  'pages.login.googleLoginSuccess': 'Google login successful',
  'pages.login.googleLoginFailed': 'Google login failed',
  'pages.login.verificationCodeSent':
    'Verification code has been sent to your email',
  'pages.login.reLogin': 'Re-login',
  'pages.login.verificationCodeFailed':
    'Failed to send verification code, please try again',
  'pages.login.countdownText': 's to resend',

  // Register modal
  'pages.register.title': 'Register Account',
  'pages.register.username': 'Username',
  'pages.register.username.required': 'Please input your username!',
  'pages.register.username.length': 'Username must be 3-30 characters',
  'pages.register.username.placeholder': '3-30 characters',
  'pages.register.email': 'Email',
  'pages.register.email.required': 'Please input your email!',
  'pages.register.email.invalid': 'Invalid email format!',
  'pages.register.email.placeholder': 'Enter your email',
  'pages.register.nickname': 'Nickname',
  'pages.register.optional': 'Optional',
  'pages.register.password': 'Password',
  'pages.register.password.required': 'Please input your password!',
  'pages.register.password.minLength': 'Password must be at least 6 characters',
  'pages.register.password.placeholder': 'At least 6 characters',
  'pages.register.password.strong': 'Strength: Strong',
  'pages.register.password.medium': 'Strength: Medium',
  'pages.register.password.weak': 'Strength: Too short',
  'pages.register.password.hint': 'Please enter at least 6 characters',
  'pages.register.password.mismatch': 'Passwords do not match!',
  'pages.register.confirmPassword': 'Confirm Password',
  'pages.register.confirmPassword.required': 'Please confirm your password',
  'pages.register.confirmPassword.placeholder': 'Re-enter password',
  'pages.register.referralCode': 'Referral Code',
  'pages.register.submit': 'Register',
  'pages.register.codeSent': 'Verification code has been sent to your email',
  'pages.register.requestFailed':
    'Registration request failed, please try again',
  'pages.register.codeSentTo': 'Verification code sent to',
  'pages.register.modifyInfo': 'Modify Info',
  'pages.register.code.required': 'Please enter verification code!',
  'pages.register.code.length': 'Verification code must be 6 digits',
  'pages.register.code.placeholder': '6-digit code',
  'pages.register.resend': 'Resend',
  'pages.register.verifyAndRegister': 'Verify & Register',
  'pages.register.success': 'Registration successful!',
  'pages.register.verifyFailed': 'Verification failed, please try again',
  'pages.register.codeResent': 'Verification code has been resent',
  'pages.register.sendCodeFailed': 'Failed to send verification code',

  // Forgot password modal
  'pages.forgotPassword.title': 'Reset Password',
  'pages.forgotPassword.step1': 'Verify Email',
  'pages.forgotPassword.step2': 'Verification',
  'pages.forgotPassword.step3': 'Reset Password',
  'pages.forgotPassword.email': 'Registered Email',
  'pages.forgotPassword.email.required': 'Please enter your email',
  'pages.forgotPassword.email.invalid': 'Invalid email format',
  'pages.forgotPassword.email.placeholder': 'Enter registered email',
  'pages.forgotPassword.sendCode': 'Send Code',
  'pages.forgotPassword.codeSent':
    'Verification code has been sent to your email',
  'pages.forgotPassword.sendFailed':
    'Failed to send verification code, please try again',
  'pages.forgotPassword.codeSentTo': 'Verification code sent to',
  'pages.forgotPassword.code.required': 'Please enter verification code',
  'pages.forgotPassword.code.length': 'Verification code must be 6 digits',
  'pages.forgotPassword.code.placeholder': '6-digit code',
  'pages.forgotPassword.resend': 'Resend',
  'pages.forgotPassword.next': 'Next',
  'pages.forgotPassword.newPassword': 'New Password',
  'pages.forgotPassword.newPassword.required': 'Please enter new password',
  'pages.forgotPassword.newPassword.minLength':
    'Password must be at least 6 characters',
  'pages.forgotPassword.newPassword.placeholder': 'At least 6 characters',
  'pages.forgotPassword.confirmPassword': 'Confirm New Password',
  'pages.forgotPassword.confirmPassword.required':
    'Please confirm new password',
  'pages.forgotPassword.confirmPassword.placeholder': 'Re-enter new password',
  'pages.forgotPassword.passwordMismatch': 'Passwords do not match!',
  'pages.forgotPassword.resetPassword': 'Reset Password',
  'pages.forgotPassword.resetSuccess': 'Password reset successful!',
  'pages.forgotPassword.resetFailed': 'Password reset failed, please try again',
  'pages.forgotPassword.successTitle': 'Password Reset Successful',
  'pages.forgotPassword.successSubtitle': 'Please login with your new password',
  'pages.forgotPassword.backToLogin': 'Back to Login',
  'pages.forgotPassword.codeResent': 'Verification code has been resent',
  'pages.forgotPassword.sendCodeFailed': 'Failed to send verification code',

  // User management page
  'pages.userManage.title': 'User List',
  'pages.userManage.column.user': 'User',
  'pages.userManage.column.username': 'Username',
  'pages.userManage.column.email': 'Email',
  'pages.userManage.column.roles': 'Roles',
  'pages.userManage.column.createdAt': 'Registered At',
  'pages.userManage.column.lastLogin': 'Last Login',
  'pages.userManage.column.status': 'Status',
  'pages.userManage.column.action': 'Action',
  'pages.userManage.search': 'Search',
  'pages.userManage.search.placeholder': 'Username/Email/Nickname/User ID',
  'pages.userManage.status.active': 'Active',
  'pages.userManage.status.banned': 'Banned',
  'pages.userManage.status.placeholder': 'Select status',
  'pages.userManage.role.admin': 'Admin',
  'pages.userManage.role.agent': 'Agent',
  'pages.userManage.role.referral': 'Referral',
  'pages.userManage.role.user': 'User',
  'pages.userManage.role.normalUser': 'Normal User',
  'pages.userManage.role.placeholder': 'Select role',
  'pages.userManage.action.detail': 'Detail',
  'pages.userManage.action.disable': 'Disable',
  'pages.userManage.action.enable': 'Enable',
  'pages.userManage.action.manageRoles': 'Manage Roles',
  'pages.userManage.action.save': 'Save',
  'pages.userManage.action.cancel': 'Cancel',
  'pages.userManage.action.confirmDisable': 'Confirm Disable',
  'pages.userManage.emailNotVerified': 'Not Verified',
  'pages.userManage.emailVerified': 'Verified',
  'pages.userManage.copied': 'Copied',
  'pages.userManage.stats.totalUsers': 'Total Users',
  'pages.userManage.stats.activeUsers': 'Active Users',
  'pages.userManage.stats.verifiedUsers': 'Verified',
  'pages.userManage.stats.recentUsers': 'Last 7 Days Registered',
  'pages.userManage.stats.recentActiveUsers': 'Last 7 Days Active',
  'pages.userManage.detail.title': 'User Detail',
  'pages.userManage.detail.basicInfo': 'Basic Info',
  'pages.userManage.detail.userId': 'User ID',
  'pages.userManage.detail.emailVerified': 'Email Verified',
  'pages.userManage.detail.nickname': 'Nickname',
  'pages.userManage.detail.loginMethods': 'Login Methods',
  'pages.userManage.detail.referralCode': 'Referral Code',
  'pages.userManage.detail.loadFailed': 'Failed to load user detail',
  'pages.userManage.detail.operationFailed': 'Operation failed',
  'pages.userManage.detail.userBanned': 'User has been banned',
  'pages.userManage.detail.userEnabled': 'User has been enabled',
  'pages.userManage.detail.rolesUpdated': 'Roles updated successfully',
  'pages.userManage.detail.rolesUpdateFailed': 'Failed to update roles',
  'pages.userManage.detail.userNotFound': 'User not found',
  'pages.userManage.confirm.banUser': 'Are you sure to ban this user?',
  'pages.userManage.confirm.banUserDesc':
    'User will not be able to login after being banned',
  'pages.userManage.confirm.enableUser': 'Are you sure to enable this user?',
  'pages.userManage.confirm.enable': 'Confirm enable?',
  'pages.userManage.apiKey.name': 'Name',
  'pages.userManage.apiKey.disabled': 'API Key has been disabled',
  'pages.userManage.apiKey.enabled': 'API Key has been enabled',
  'pages.userManage.apiKey.statusDisabled': 'Disabled',
  'pages.userManage.modal.manageRoles': 'Manage User Roles',
  'pages.userManage.modal.selectRoles': 'Select Roles',
  'pages.userManage.modal.rolesHint':
    'Note: User needs to re-login for role changes to take effect.',
  'pages.userManage.modal.disableApiKey': 'Disable API Key',
  'pages.userManage.modal.disableApiKeyConfirm':
    'Are you sure to disable this API Key?',
  'pages.userManage.modal.disableReasonPlaceholder':
    'Enter reason for disabling (optional)',

  // User Session Management (Admin)
  'pages.userManage.sessions.title': 'Sessions',
  'pages.userManage.sessions.description':
    'Manage the logged-in devices of this user',
  'pages.userManage.sessions.historyDescription':
    'View the login history of this user',
  'pages.userManage.sessions.tab.devices': 'Devices',
  'pages.userManage.sessions.tab.history': 'Login History',
  'pages.userManage.sessions.loadFailed': 'Failed to load',
  'pages.userManage.sessions.empty': 'No sessions',
  'pages.userManage.sessions.historyEmpty': 'No login records',
  'pages.userManage.sessions.total': '{total} device(s)',
  'pages.userManage.sessions.historyTotal': '{total} record(s)',
  'pages.userManage.sessions.revokeAll': 'Force Logout All Devices',
  'pages.userManage.sessions.revokeAllTitle': 'Force Logout All Devices',
  'pages.userManage.sessions.revokeAllContent':
    'Are you sure you want to force logout all devices of this user? This action cannot be undone.',
  'pages.userManage.sessions.revokeAllSuccess': '{count} device(s) logged out',
  'pages.userManage.sessions.revokeAllFailed': 'Failed to logout',
  'pages.userManage.sessions.revokeConfirm':
    'Are you sure you want to logout this device?',
  'pages.userManage.sessions.revokeSuccess': 'Session revoked',
  'pages.userManage.sessions.revokeFailed': 'Failed to revoke',
  'pages.userManage.sessions.revoke': 'Logout',
  'pages.userManage.sessions.confirm': 'Confirm',
  'pages.userManage.sessions.cancel': 'Cancel',
  'pages.userManage.sessions.search': 'Search',
  'pages.userManage.sessions.filterStatus': 'Filter Status',
  'pages.userManage.sessions.column.device': 'Device',
  'pages.userManage.sessions.column.location': 'Location',
  'pages.userManage.sessions.column.loginMethod': 'Login Method',
  'pages.userManage.sessions.column.lastActive': 'Last Active',
  'pages.userManage.sessions.column.action': 'Action',
  'pages.userManage.sessions.column.time': 'Time',
  'pages.userManage.sessions.column.status': 'Status',
  'pages.userManage.sessions.device.desktop': 'Desktop',
  'pages.userManage.sessions.device.mobile': 'Mobile',
  'pages.userManage.sessions.device.tablet': 'Tablet',
  'pages.userManage.sessions.device.unknown': 'Unknown',
  'pages.userManage.sessions.loginMethod.password': 'Password',
  'pages.userManage.sessions.loginMethod.google': 'Google',
  'pages.userManage.sessions.loginMethod.apikey': 'API Key',
  'pages.userManage.sessions.status.success': 'Success',
  'pages.userManage.sessions.status.failed': 'Failed',

  // User Transactions
  'pages.userManage.transactions.title': 'Transactions',
  'pages.userManage.transactions.description':
    'View deposit and withdrawal records of this user',
  'pages.userManage.transactions.empty': 'No transaction records',
  'pages.userManage.transactions.total': 'Total {total} records',
  'pages.userManage.transactions.loadFailed':
    'Failed to load transaction records',

  // User Balance
  'pages.userManage.balance.title': 'Asset Balance',
  'pages.userManage.balance.empty': 'No asset data',
  'pages.userManage.balance.available': 'Available',
  'pages.userManage.balance.frozen': 'Frozen',
  'pages.userManage.balance.adjust': 'Adjust',
  'pages.userManage.balance.adjustTitle': 'Adjust User Balance',
  'pages.userManage.balance.currentBalance': 'Current Balance',
  'pages.userManage.balance.adjustAmount': 'Adjustment Amount',
  'pages.userManage.balance.adjustAmount.required':
    'Please enter adjustment amount',
  'pages.userManage.balance.adjustAmount.notZero':
    'Adjustment amount cannot be 0',
  'pages.userManage.balance.adjustAmount.hint':
    'Positive to increase, negative to decrease',
  'pages.userManage.balance.adjustAmount.placeholder': 'e.g. 100 or -50',
  'pages.userManage.balance.adjustRemark': 'Reason',
  'pages.userManage.balance.adjustRemark.required': 'Please enter the reason',
  'pages.userManage.balance.adjustRemark.placeholder':
    'e.g. Admin manual top-up',
  'pages.userManage.balance.confirmAdjust': 'Confirm Adjust',
  'pages.userManage.balance.adjustSuccess':
    'Balance adjusted successfully, new balance: {balance}',
  'pages.userManage.balance.adjustFailed': 'Failed to adjust balance',

  // User Transaction History
  'pages.userManage.history.title': 'Transaction History',
  'pages.userManage.history.description':
    'View all transaction records of this user',
  'pages.userManage.history.empty': 'No transaction records',
  'pages.userManage.history.total': 'Total {total} records',
  'pages.userManage.history.loadFailed': 'Failed to load transaction records',
  'pages.userManage.history.column.type': 'Type',
  'pages.userManage.history.type.deposit': 'Deposit',
  'pages.userManage.history.type.withdrawal': 'Withdrawal',
  'pages.userManage.history.type.internal_transfer': 'Internal Transfer',
  'pages.userManage.history.type.internal_deposit': 'Internal Deposit',

  // User Cards Management (UserDetailModal)
  'pages.userManage.cards.title': 'User Cards',
  'pages.userManage.cards.description': 'View all cards of this user',
  'pages.userManage.cards.empty': 'No cards',
  'pages.userManage.cards.total': '{total} cards in total',
  'pages.userManage.cards.loadDetailFailed': 'Load detail failed',
  'pages.userManage.cards.loadTransactionsFailed': 'Load transactions failed',
  'pages.userManage.cards.noChanges': 'No changes made',
  'pages.userManage.cards.updateSuccess': 'Update successful',
  'pages.userManage.cards.updateFailed': 'Update failed',
  'pages.userManage.cards.column.cardNumber': 'Card Number',
  'pages.userManage.cards.column.holderName': 'Holder Name',
  'pages.userManage.cards.column.cardOrg': 'Card Org',
  'pages.userManage.cards.column.balance': 'Balance',
  'pages.userManage.cards.column.status': 'Status',
  'pages.userManage.cards.column.createdAt': 'Created At',
  'pages.userManage.cards.column.action': 'Action',
  'pages.userManage.cards.status.active': 'Active',
  'pages.userManage.cards.status.frozen': 'Frozen',
  'pages.userManage.cards.status.cancelled': 'Cancelled',
  'pages.userManage.cards.action.detail': 'Detail',
  'pages.userManage.cards.action.transactions': 'Records',
  'pages.userManage.cards.action.edit': 'Edit',
  'pages.userManage.cards.detail.title': 'Card Detail',
  'pages.userManage.cards.detail.basicInfo': 'Basic Info',
  'pages.userManage.cards.detail.sensitiveInfo': 'Sensitive Info',
  'pages.userManage.cards.detail.showSensitive': 'Show',
  'pages.userManage.cards.detail.hideSensitive': 'Hide',
  'pages.userManage.cards.detail.fullCardNumber': 'Full Card Number',
  'pages.userManage.cards.detail.expireDate': 'Expire Date',
  'pages.userManage.cards.detail.clickToShow':
    'Click the button above to show sensitive info',
  'pages.userManage.cards.transactions.title': 'Card Transactions',
  'pages.userManage.cards.transactions.total': '{total} records in total',
  'pages.userManage.cards.transactions.column.time': 'Time',
  'pages.userManage.cards.transactions.column.type': 'Type',
  'pages.userManage.cards.transactions.column.amount': 'Amount',
  'pages.userManage.cards.transactions.column.fee': 'Fee',
  'pages.userManage.cards.transactions.column.balance': 'Balance Change',
  'pages.userManage.cards.transactions.column.merchant': 'Merchant',
  'pages.userManage.cards.transactions.type.recharge': 'Recharge',
  'pages.userManage.cards.transactions.type.withdraw': 'Withdraw',
  'pages.userManage.cards.transactions.type.payment': 'Payment',
  'pages.userManage.cards.transactions.type.refund': 'Refund',
  'pages.userManage.cards.edit.title': 'Edit Card',
  'pages.userManage.cards.edit.sensitiveFields': 'Sensitive Fields (Optional)',
  'pages.userManage.cards.edit.leaveEmptyNoChange':
    'Leave empty to keep unchanged',

  // Admin User Cards Management Page
  'pages.adminUserCards.title': 'User Cards Management',
  'pages.adminUserCards.loadDetailFailed': 'Load detail failed',
  'pages.adminUserCards.loadTransactionsFailed': 'Load transactions failed',
  'pages.adminUserCards.noChanges': 'No changes made',
  'pages.adminUserCards.updateSuccess': 'Update successful',
  'pages.adminUserCards.updateFailed': 'Update failed',
  'pages.adminUserCards.copied': '{field} copied',
  'pages.adminUserCards.stats.total': 'Total Cards',
  'pages.adminUserCards.stats.active': 'Active Cards',
  'pages.adminUserCards.stats.frozen': 'Frozen Cards',
  'pages.adminUserCards.stats.cancelled': 'Cancelled',
  'pages.adminUserCards.column.userId': 'User ID',
  'pages.adminUserCards.column.cardNumber': 'Card Number',
  'pages.adminUserCards.column.holderName': 'Holder Name',
  'pages.adminUserCards.column.cardOrg': 'Card Org',
  'pages.adminUserCards.column.balance': 'Balance',
  'pages.adminUserCards.column.status': 'Status',
  'pages.adminUserCards.column.createdAt': 'Created At',
  'pages.adminUserCards.column.action': 'Action',
  'pages.adminUserCards.status.active': 'Active',
  'pages.adminUserCards.status.frozen': 'Frozen',
  'pages.adminUserCards.status.cancelled': 'Cancelled',
  'pages.adminUserCards.action.detail': 'Detail',
  'pages.adminUserCards.action.transactions': 'Records',
  'pages.adminUserCards.action.edit': 'Edit',
  'pages.adminUserCards.action.refresh': 'Refresh',
  'pages.adminUserCards.detail.title': 'Card Detail',
  'pages.adminUserCards.detail.basicInfo': 'Basic Info',
  'pages.adminUserCards.detail.sensitiveInfo': 'Sensitive Info',
  'pages.adminUserCards.detail.showSensitive': 'Show',
  'pages.adminUserCards.detail.hideSensitive': 'Hide',
  'pages.adminUserCards.detail.fullCardNumber': 'Full Card Number',
  'pages.adminUserCards.detail.expireDate': 'Expire Date',
  'pages.adminUserCards.detail.clickToShow':
    'Click the button above to show sensitive info',
  'pages.adminUserCards.transactions.title': 'Transactions',
  'pages.adminUserCards.transactions.total': '{total} records in total',
  'pages.adminUserCards.transactions.column.transactionNo': 'Transaction No.',
  'pages.adminUserCards.transactions.column.time': 'Created At',
  'pages.adminUserCards.transactions.column.completedAt': 'Completed At',
  'pages.adminUserCards.transactions.column.type': 'Type',
  'pages.adminUserCards.transactions.column.amount': 'Amount',
  'pages.adminUserCards.transactions.column.fee': 'Fee',
  'pages.adminUserCards.transactions.column.actualAmount': 'Actual Amount',
  'pages.adminUserCards.transactions.column.balance': 'Balance Change',
  'pages.adminUserCards.transactions.column.status': 'Status',
  'pages.adminUserCards.transactions.column.merchant': 'Merchant',
  'pages.adminUserCards.transactions.column.upstreamFee': 'Upstream Cost',
  'pages.adminUserCards.transactions.column.upstreamOrderNo': 'Upstream Order',
  'pages.adminUserCards.transactions.column.platformFee': 'Platform Revenue',
  'pages.adminUserCards.transactions.upstreamAmount': 'Amount',
  'pages.adminUserCards.transactions.upstreamFee': 'Fee',
  'pages.adminUserCards.transactions.platformFee': 'Fee',
  'pages.adminUserCards.transactions.platformProfit': 'Profit',
  'pages.adminUserCards.transactions.type.recharge': 'Recharge',
  'pages.adminUserCards.transactions.type.withdraw': 'Withdraw',
  'pages.adminUserCards.transactions.type.payment': 'Payment',
  'pages.adminUserCards.transactions.type.refund': 'Refund',
  'pages.adminUserCards.transactions.status.success': 'Success',
  'pages.adminUserCards.transactions.status.pending': 'Pending',
  'pages.adminUserCards.transactions.status.failed': 'Failed',
  'pages.adminUserCards.edit.title': 'Edit Card',
  'pages.adminUserCards.edit.sensitiveFields': 'Sensitive Fields (Optional)',
  'pages.adminUserCards.edit.leaveEmptyNoChange':
    'Leave empty to keep unchanged',

  // Card Application Management
  'pages.cardApplication.title': 'Card Application Management',
  'pages.cardApplication.loadFailed': 'Load failed',
  'pages.cardApplication.loadDetailFailed': 'Load detail failed',
  'pages.cardApplication.updateSuccess': 'Update successful',
  'pages.cardApplication.updateFailed': 'Update failed',
  'pages.cardApplication.column.applicationNo': 'Application No',
  'pages.cardApplication.column.userId': 'User ID',
  'pages.cardApplication.column.cardProduct': 'Card Product',
  'pages.cardApplication.column.issueFee': 'Issue Fee',
  'pages.cardApplication.column.kycLevel': 'KYC Level',
  'pages.cardApplication.kycLevel.notSubmitted': 'Not Submitted',
  'pages.cardApplication.column.status': 'Status',
  'pages.cardApplication.column.createdAt': 'Created At',
  'pages.cardApplication.column.action': 'Action',
  'pages.cardApplication.status.pending': 'Pending',
  'pages.cardApplication.status.kyc_failed': 'KYC Failed',
  'pages.cardApplication.status.payment_failed': 'Payment Failed',
  'pages.cardApplication.status.paid': 'Paid',
  'pages.cardApplication.status.processing': 'Processing',
  'pages.cardApplication.status.shipped': 'Shipped',
  'pages.cardApplication.status.pending_assign': 'Pending Assign',
  'pages.cardApplication.status.assigned': 'Pending Activation',
  'pages.cardApplication.status.pending_activation': 'Pending Activation',
  'pages.cardApplication.status.success': 'Success',
  'pages.cardApplication.status.failed': 'Failed',
  'pages.cardApplication.status.cancelled': 'Cancelled',
  'pages.cardApplication.stats.total': 'Total Applications',
  'pages.cardApplication.stats.pending': 'Pending',
  'pages.cardApplication.stats.paid': 'Paid',
  'pages.cardApplication.stats.processing': 'Processing',
  'pages.cardApplication.stats.shipped': 'Shipped',
  'pages.cardApplication.stats.pending_assign': 'Pending Assign',
  'pages.cardApplication.stats.assigned': 'Pending Activation',
  'pages.cardApplication.stats.pending_activation': 'Pending Activation',
  'pages.cardApplication.stats.success': 'Success',
  'pages.cardApplication.stats.failed': 'Failed',
  'pages.cardApplication.filter.all': 'All Status',
  'pages.cardApplication.filter.userId': 'User ID',
  'pages.cardApplication.filter.search': 'Search',
  'pages.cardApplication.action.view': 'View',
  'pages.cardApplication.action.update': 'Update',
  'pages.cardApplication.action.refresh': 'Refresh',
  'pages.cardApplication.pagination.total': 'Total {total}',
  'pages.cardApplication.detail.title': 'Application Detail',
  'pages.cardApplication.detail.applicationInfo': 'Application Info',
  'pages.cardApplication.detail.cardInfo': 'Card Product Info',
  'pages.cardApplication.detail.kycInfo': 'KYC Info',
  'pages.cardApplication.detail.paidAt': 'Paid At',
  'pages.cardApplication.detail.statusMessage': 'Status Message',
  'pages.cardApplication.detail.cardNumber': 'Card Number',
  'pages.cardApplication.detail.cardHolder': 'Card Holder',
  'pages.cardApplication.detail.cardName': 'Card Name',
  'pages.cardApplication.detail.kycStatus': 'KYC Status',
  'pages.cardApplication.detail.cardNotFound': 'Card product info not found',
  'pages.cardApplication.detail.kycNotFound': 'KYC detail info not found',
  'pages.cardApplication.detail.kycNotSubmitted': 'KYC Not Submitted',
  'pages.cardApplication.update.title': 'Update Application Status',
  'pages.cardApplication.update.confirm': 'Confirm Update',
  'pages.cardApplication.update.statusRequired': 'Please select status',
  'pages.cardApplication.update.statusMessagePlaceholder':
    'Optional, reason for status change',
  // Upstream operations
  'pages.cardApplication.detail.upstreamInfo': 'Upstream Operations',
  'pages.cardApplication.upstream.createHolder': 'Create Holder',
  'pages.cardApplication.upstream.createCard': 'Create Card',
  'pages.cardApplication.upstream.status.success': 'Success',
  'pages.cardApplication.upstream.status.failed': 'Failed',
  'pages.cardApplication.upstream.status.pending': 'Processing',
  'pages.cardApplication.upstream.requestTime': 'Request Time',
  'pages.cardApplication.upstream.responseTime': 'Response Time',
  'pages.cardApplication.upstream.upstreamId': 'Upstream ID',
  'pages.cardApplication.upstream.callbackTime': 'Callback Time',
  'pages.cardApplication.upstream.requestData': 'Request Data',
  'pages.cardApplication.upstream.responseData': 'Response Data',
  'pages.cardApplication.upstream.callbackData': 'Callback Data',
  'pages.cardApplication.upstream.noData': 'No upstream operations',
  'pages.cardApplication.action.applyUpstream': 'Apply to Upstream',
  'pages.cardApplication.action.manage': 'Manage',
  'pages.cardApplication.applyUpstream.confirmTitle':
    'Confirm Apply to Upstream',
  'pages.cardApplication.applyUpstream.confirmContent':
    'Are you sure you want to apply for a card from upstream? Application No: {applicationNo}',
  'pages.cardApplication.applyUpstream.confirm': 'Confirm',
  'pages.cardApplication.applyUpstream.success': 'Application submitted',
  'pages.cardApplication.applyUpstream.failed': 'Application failed',
  'pages.cardApplication.manage.title': 'Application Management',
  'pages.cardApplication.manage.finalStatusAlert':
    'This application is in final status and cannot be modified',
  'pages.cardApplication.manage.operations': 'Operations',
  'pages.cardApplication.manage.applyUpstreamHint':
    'Click to submit card application to upstream provider',
  'pages.cardApplication.manage.updateStatus': 'Update Status',
  'pages.cardApplication.manage.refundOption':
    'Refund issue fee ({fee} {currency})',
  'pages.cardApplication.action.refund': 'Refund',
  'pages.cardApplication.refund.confirmTitle': 'Confirm Refund',
  'pages.cardApplication.refund.confirmContent':
    'Are you sure you want to refund {fee} {currency} to the user? Application No: {applicationNo}',
  'pages.cardApplication.refund.confirm': 'Confirm Refund',
  'pages.cardApplication.refund.hint':
    'Cancel the application and refund issue fee {fee} {currency}',
  'pages.cardApplication.refund.statusMessage':
    'Manually refunded and cancelled by admin',
  'pages.cardApplication.refund.success': 'Refund successful',
  'pages.cardApplication.refund.successWithAmount':
    'Refund successful, {amount} {currency} has been refunded',
  'pages.cardApplication.refund.failed': 'Refund failed',
  // Shipping related
  'pages.cardApplication.action.ship': 'Ship',
  'pages.cardApplication.manage.shipHint':
    'Enter shipping company and tracking number to ship',
  'pages.cardApplication.ship.confirmTitle': 'Confirm Shipment',
  'pages.cardApplication.ship.confirmContent':
    'Please fill in shipping information:',
  'pages.cardApplication.ship.confirm': 'Confirm Ship',
  'pages.cardApplication.ship.shippingCompanyLabel': 'Shipping Company:',
  'pages.cardApplication.ship.shippingCompanyPlaceholder':
    'e.g. SF Express, DHL, FedEx',
  'pages.cardApplication.ship.shippingCompanyRequired':
    'Please enter shipping company',
  'pages.cardApplication.ship.trackingNumberLabel': 'Tracking Number:',
  'pages.cardApplication.ship.trackingNumberPlaceholder': 'Tracking Number',
  'pages.cardApplication.ship.trackingNumberRequired':
    'Please enter tracking number',
  'pages.cardApplication.ship.success': 'Shipment successful',
  'pages.cardApplication.ship.failed': 'Shipment failed',
  // Shipping address related
  'pages.cardApplication.detail.shippingAddress': 'Shipping Address',
  'pages.cardApplication.detail.recipientName': 'Recipient',
  'pages.cardApplication.detail.recipientPhone': 'Phone',
  'pages.cardApplication.detail.country': 'Country',
  'pages.cardApplication.detail.province': 'Province/State',
  'pages.cardApplication.detail.city': 'City',
  'pages.cardApplication.detail.address': 'Address',
  'pages.cardApplication.detail.postalCode': 'Postal Code',
  'pages.cardApplication.detail.shippingCompany': 'Shipping Company',
  'pages.cardApplication.detail.trackingNumber': 'Tracking Number',
  'pages.cardApplication.detail.shippedAt': 'Shipped At',
  // Assign/Activate info related
  'pages.cardApplication.detail.assignActivateInfo': 'Assign/Activate Info',
  'pages.cardApplication.detail.cardNo': 'User Submitted Card No',
  'pages.cardApplication.detail.upstreamCardId': 'Upstream Card ID',
  'pages.cardApplication.detail.activateCode': 'Activation Code',
  'pages.cardApplication.detail.pin': 'PIN Code',
  // Approve assign related
  'pages.cardApplication.action.approveAssign': 'Approve Assign',
  'pages.cardApplication.approveAssign.hint':
    'System will call upstream to assign card after approval',
  'pages.cardApplication.approveAssign.confirmTitle': 'Confirm Approve Assign',
  'pages.cardApplication.approveAssign.confirmContent':
    'System will automatically call upstream AssignCard API after confirmation',
  'pages.cardApplication.approveAssign.confirm': 'Confirm',
  'pages.cardApplication.approveAssign.success':
    'Approved successfully, assign request submitted',
  'pages.cardApplication.approveAssign.failed': 'Approval failed',
  // Approve activation related
  'pages.cardApplication.action.approveActivation': 'Approve Activation',
  'pages.cardApplication.approveActivation.hint':
    'System will call upstream to activate card after approval',
  'pages.cardApplication.approveActivation.confirmTitle':
    'Confirm Approve Activation',
  'pages.cardApplication.approveActivation.confirmContent':
    'System will automatically call upstream ActivateCard API after confirmation',
  'pages.cardApplication.approveActivation.confirm': 'Confirm',
  'pages.cardApplication.approveActivation.success':
    'Approved successfully, activation request submitted',
  'pages.cardApplication.approveActivation.failed': 'Approval failed',

  // Retry Assign (physical card failed -> assigned)
  'pages.cardApplication.action.retryAssign': 'Retry Assign',
  'pages.cardApplication.retryAssign.hint':
    'Retry calling upstream AssignCard API',
  'pages.cardApplication.retryAssign.confirmTitle': 'Confirm Retry Assign',
  'pages.cardApplication.retryAssign.confirmContent':
    'The system will retry calling upstream AssignCard API to assign the card',
  'pages.cardApplication.retryAssign.confirm': 'Confirm Retry',
  'pages.cardApplication.retryAssign.success': 'Retry assign request submitted',
  'pages.cardApplication.retryAssign.failed': 'Retry assign failed',

  // Retry Activate (physical card failed -> success)
  'pages.cardApplication.action.retryActivate': 'Retry Activate',
  'pages.cardApplication.retryActivate.hint':
    'Retry calling upstream ActivateCard API',
  'pages.cardApplication.retryActivate.confirmTitle': 'Confirm Retry Activate',
  'pages.cardApplication.retryActivate.confirmContent':
    'The system will retry calling upstream ActivateCard API to activate the card',
  'pages.cardApplication.retryActivate.confirm': 'Confirm Retry',
  'pages.cardApplication.retryActivate.success':
    'Retry activate request submitted',
  'pages.cardApplication.retryActivate.failed': 'Retry activate failed',

  // Role management page
  'pages.roleManage.title': 'Role Permission Management',
  'pages.roleManage.roleList': 'Role List',
  'pages.roleManage.role.admin': 'Admin',
  'pages.roleManage.role.admin.desc': 'Has all system permissions',
  'pages.roleManage.role.agent': 'Agent',
  'pages.roleManage.role.agent.desc':
    'Agent role with partial management permissions',
  'pages.roleManage.role.referral': 'Referral',
  'pages.roleManage.role.referral.desc':
    'Referral role, can view referral data',
  'pages.roleManage.role.user': 'Normal User',
  'pages.roleManage.role.user.desc': 'Normal user with basic permissions',
  'pages.roleManage.systemRole': 'System',
  'pages.roleManage.systemRoleTag': 'System Role',
  'pages.roleManage.customRoleTag': 'Custom',
  'pages.roleManage.configPermission': 'Configure Permissions',
  'pages.roleManage.selectRole': 'Please select a role',
  'pages.roleManage.selectRoleToConfig': 'Please select a role to configure',
  'pages.roleManage.roleIdentifier': 'Role Identifier',
  'pages.roleManage.selectedPermissions': 'Selected Permissions',
  'pages.roleManage.items': 'items',
  'pages.roleManage.permissionConfig': 'Permission Configuration',
  'pages.roleManage.permissionUpdated': 'Permission updated',
  'pages.roleManage.roleUpdated': 'Role updated',
  'pages.roleManage.resetSuccess': 'Reset to default permissions',
  'pages.roleManage.action.resetDefault': 'Reset Default',
  'pages.roleManage.action.edit': 'Edit',
  'pages.roleManage.action.save': 'Save',
  'pages.roleManage.confirm.reset':
    'Are you sure to reset to default permissions?',
  'pages.roleManage.confirm.ok': 'OK',
  'pages.roleManage.confirm.cancel': 'Cancel',
  'pages.roleManage.modal.editRole': 'Edit Role',
  'pages.roleManage.modal.addRole': 'Add Role',
  'pages.roleManage.form.roleName': 'Role Name',
  'pages.roleManage.form.roleName.required': 'Please enter role name',
  'pages.roleManage.form.roleName.placeholder': 'Enter role name',
  'pages.roleManage.form.roleDesc': 'Role Description',
  'pages.roleManage.form.roleDesc.placeholder': 'Enter role description',

  // KYC management page
  'pages.kycManage.title': 'KYC Management',
  'pages.kycManage.stats.total': 'Total KYC',
  'pages.kycManage.stats.pendingLevel1': 'Level 1 Pending',
  'pages.kycManage.stats.pendingLevel2': 'Level 2 Pending',
  'pages.kycManage.stats.pendingLevel3': 'Level 3 Pending',
  'pages.kycManage.stats.approvedToday': 'Approved Today',
  'pages.kycManage.stats.rejectedToday': 'Rejected Today',
  'pages.kycManage.column.userId': 'User ID',
  'pages.kycManage.column.name': 'Name',
  'pages.kycManage.column.idNumber': 'ID Number',
  'pages.kycManage.column.idType': 'ID Type',
  'pages.kycManage.column.currentLevel': 'Current Level',
  'pages.kycManage.column.status': 'Status',
  'pages.kycManage.column.submittedAt': 'Submitted At',
  'pages.kycManage.column.action': 'Action',
  'pages.kycManage.status.pending': 'Pending',
  'pages.kycManage.status.approved': 'Approved',
  'pages.kycManage.status.rejected': 'Rejected',
  'pages.kycManage.idType.id_card': 'ID Card',
  'pages.kycManage.idType.passport': 'Passport',
  'pages.kycManage.idType.driver_license': 'Driver License',
  'pages.kycManage.level.0': 'Not Verified',
  'pages.kycManage.level.1': 'Level 1',
  'pages.kycManage.level.2': 'Level 2',
  'pages.kycManage.level.3': 'Level 3',
  'pages.kycManage.action.view': 'View',
  'pages.kycManage.action.review': 'Review',
  'pages.kycManage.filter.all': 'All',
  'pages.kycManage.filter.pending': 'Pending',
  'pages.kycManage.filter.approved': 'Approved',
  'pages.kycManage.filter.rejected': 'Rejected',
  'pages.kycManage.filter.level': 'Filter Level',
  'pages.kycManage.search.placeholder': 'Search name or ID number',
  'pages.kycManage.detail.title': 'KYC Detail',
  'pages.kycManage.detail.basicInfo': 'Basic Info',
  'pages.kycManage.detail.level1': 'Level 1 - Identity Verification',
  'pages.kycManage.detail.level2': 'Level 2 - Advanced Verification',
  'pages.kycManage.detail.level3': 'Level 3 - Professional Verification',
  'pages.kycManage.detail.firstName': 'First Name',
  'pages.kycManage.detail.lastName': 'Last Name',
  'pages.kycManage.detail.fullName': 'Full Name',
  'pages.kycManage.detail.gender': 'Gender',
  'pages.kycManage.detail.gender.male': 'Male',
  'pages.kycManage.detail.gender.female': 'Female',
  'pages.kycManage.detail.birthday': 'Birthday',
  'pages.kycManage.detail.email': 'Email',
  'pages.kycManage.detail.phone': 'Phone',
  'pages.kycManage.detail.country': 'Country/Region',
  'pages.kycManage.detail.address': 'Address',
  'pages.kycManage.detail.postCode': 'Post Code',
  'pages.kycManage.detail.idPhotos': 'ID Photos',
  'pages.kycManage.detail.idFront': 'Front',
  'pages.kycManage.detail.idBack': 'Back',
  'pages.kycManage.detail.facePhoto': 'Face Photo',
  'pages.kycManage.detail.addressProof': 'Address Proof',
  'pages.kycManage.detail.incomeProof': 'Income Proof',
  'pages.kycManage.detail.resume': 'Resume',
  'pages.kycManage.detail.taxProof': 'Tax Proof',
  'pages.kycManage.detail.otherDocs': 'Other Documents',
  'pages.kycManage.detail.notSubmitted': 'Not Submitted',
  'pages.kycManage.detail.reviewedBy': 'Reviewed By',
  'pages.kycManage.detail.reviewedAt': 'Reviewed At',
  'pages.kycManage.detail.rejectReason': 'Reject Reason',
  'pages.kycManage.review.title': 'Review KYC',
  'pages.kycManage.review.approve': 'Approve',
  'pages.kycManage.review.reject': 'Reject',
  'pages.kycManage.review.rejectReason': 'Reject Reason',
  'pages.kycManage.review.rejectReason.required': 'Please enter reject reason',
  'pages.kycManage.review.rejectReason.placeholder':
    'Enter reject reason, user will see this',
  'pages.kycManage.review.success': 'Review successful',
  'pages.kycManage.review.failed': 'Review failed',
  'pages.kycManage.review.confirm.approve': 'Confirm to approve this level?',
  'pages.kycManage.review.confirm.reject': 'Confirm to reject this level?',
  'pages.kycManage.loadFailed': 'Load failed',
  // Auto review
  'pages.kycManage.autoReview.label': 'Auto Review (L1)',
  'pages.kycManage.autoReview.tooltip':
    'When enabled, Level 1 KYC will be auto-approved if format validation passes',
  'pages.kycManage.autoReview.on': 'ON',
  'pages.kycManage.autoReview.off': 'OFF',
  'pages.kycManage.autoReview.enabled': 'Auto review enabled',
  'pages.kycManage.autoReview.disabled': 'Auto review disabled',
  'pages.kycManage.autoReview.failed': 'Failed to update auto review status',
  // Validation result
  'pages.kycManage.detail.validationResult': 'Validation Result',
  'pages.kycManage.detail.validationPassed': 'All format validations passed',
  'pages.kycManage.detail.validationFailed': 'Format validation failed',
  'pages.kycManage.detail.autoApproved': 'Auto approved by system',
  'pages.kycManage.detail.autoApprovedTag': 'Auto Approved',
  // Reject codes
  'pages.kycManage.review.rejectCode': 'Reject Reason',
  'pages.kycManage.review.rejectCode.placeholder': 'Select reject reason',
  'pages.kycManage.review.rejectCode.required': 'Please select a reject reason',
  'pages.kycManage.review.pendingLevel': 'Pending Level',
  'pages.kycManage.rejectCode.INVALID_NAME_FORMAT': 'Name must be in English',
  'pages.kycManage.rejectCode.INVALID_COUNTRY_CODE': 'Invalid country code',
  'pages.kycManage.rejectCode.INVALID_PHONE_FORMAT': 'Invalid phone format',
  'pages.kycManage.rejectCode.INVALID_PHONE_LENGTH': 'Invalid phone length',
  'pages.kycManage.rejectCode.INVALID_EMAIL': 'Invalid email format',
  'pages.kycManage.rejectCode.INVALID_DATE_FORMAT': 'Invalid date format',
  'pages.kycManage.rejectCode.UNDERAGE': 'Under 18 years old',
  'pages.kycManage.rejectCode.INVALID_AGE': 'Invalid age',
  'pages.kycManage.rejectCode.DUPLICATE_ID_NUMBER': 'ID number already used',
  'pages.kycManage.rejectCode.DUPLICATE_EMAIL': 'Email already used',
  'pages.kycManage.rejectCode.DUPLICATE_PHONE': 'Phone already used',
  'pages.kycManage.rejectCode.DUPLICATE_NAME': 'Name already used',
  'pages.kycManage.rejectCode.BLURRY_DOCUMENT': 'Document photo is blurry',
  'pages.kycManage.rejectCode.EXPIRED_DOCUMENT': 'Document has expired',
  'pages.kycManage.rejectCode.INVALID_DOCUMENT': 'Invalid document',
  'pages.kycManage.rejectCode.FACE_MISMATCH': 'Face does not match document',
  'pages.kycManage.rejectCode.OTHER': 'Other reason',

  // User KYC info
  'pages.userManage.kyc.title': 'KYC Verification',
  'pages.userManage.kyc.empty': 'No KYC records',
  'pages.userManage.kyc.loadFailed': 'Failed to load KYC records',
  'pages.userManage.kyc.currentLevel': 'Current Level',
  'pages.userManage.kyc.viewDetail': 'View Detail',
  'pages.userManage.kyc.count': '{count} KYC identities',
  'pages.userManage.kyc.identity': 'Identity',
  'pages.userManage.kyc.updatedAt': 'Updated At',

  // Card management
  'pages.cardManage.title': 'Card Management',
  'pages.cardManage.description': 'Manage platform card products',
  'pages.cardManage.column.id': 'ID',
  'pages.cardManage.column.cardId': 'Card ID',
  'pages.cardManage.column.displayName': 'Product Name',
  'pages.cardManage.column.displayNameEn': 'Name (EN)',
  'pages.cardManage.column.displayNameZh': 'Name (ZH)',
  'pages.cardManage.column.description': 'Description',
  'pages.cardManage.column.descriptionEn': 'Description (EN)',
  'pages.cardManage.column.descriptionZh': 'Description (ZH)',
  'pages.cardManage.column.provider': 'Provider',
  'pages.cardManage.column.currency': 'Currency',
  'pages.cardManage.column.cardBin': 'Card BIN',
  'pages.cardManage.column.cardNetwork': 'Card Network',
  'pages.cardManage.column.cardType': 'Card Type',
  'pages.cardManage.column.supportedPayments': 'Platforms',
  'pages.cardManage.column.issueRegion': 'Issue Region',
  'pages.cardManage.column.isRecommended': 'Recommended',
  'pages.cardManage.column.autoIssue': 'Issue Mode',
  'pages.cardManage.autoIssue.auto': 'Auto Issue',
  'pages.cardManage.autoIssue.manual': 'Manual Review',
  'pages.cardManage.autoIssue.auto.desc':
    'After payment, card issuance is automatically initiated, status changes to Processing',
  'pages.cardManage.autoIssue.manual.desc':
    'After payment, status changes to Paid, admin review required for issuance',
  'pages.cardManage.column.issueFee': 'Issue Fee',
  'pages.cardManage.column.annualFee': 'Annual Fee',
  'pages.cardManage.column.rechargeFeeRate': 'Recharge Fee Rate',
  'pages.cardManage.column.withdrawFeeRate': 'Withdraw Fee Rate',
  'pages.cardManage.column.transactionFeeRate': 'Transaction Fee Rate',
  'pages.cardManage.column.minRecharge': 'Min Recharge',
  'pages.cardManage.column.maxRecharge': 'Max Recharge',
  'pages.cardManage.column.dailyLimit': 'Daily Limit',
  'pages.cardManage.column.monthlyLimit': 'Monthly Limit',
  'pages.cardManage.column.yearlyLimit': 'Yearly Limit',
  'pages.cardManage.column.maxOpenCardCount': 'Max Cards',
  'pages.cardManage.column.validityYears': 'Validity (Years)',
  'pages.cardManage.column.isActive': 'Status',
  'pages.cardManage.column.sortOrder': 'Sort Order',
  'pages.cardManage.column.createdAt': 'Created At',
  'pages.cardManage.column.updatedAt': 'Updated At',
  'pages.cardManage.column.action': 'Action',
  'pages.cardManage.action.edit': 'Edit',
  'pages.cardManage.status.active': 'Active',
  'pages.cardManage.status.inactive': 'Inactive',
  'pages.cardManage.loadFailed': 'Load failed',
  'pages.cardManage.tab.products': 'Card Products',
  'pages.cardManage.tab.upstream': 'Upstream',
  // Upstream management
  'pages.cardManage.upstream.title': 'Upstream Products',
  'pages.cardManage.upstream.sync': 'Sync Upstream',
  'pages.cardManage.upstream.syncing': 'Syncing...',
  'pages.cardManage.upstream.syncSuccess':
    'Sync completed, {count} products synced',
  'pages.cardManage.upstream.syncFailed': 'Sync failed',
  'pages.cardManage.upstream.manualInput': 'Manual Input',
  // Manual input
  'pages.cardManage.manual.title': 'Manual Input Product',
  'pages.cardManage.manual.submit': 'Confirm',
  'pages.cardManage.manual.success': 'Product created successfully',
  'pages.cardManage.manual.failed': 'Product creation failed',
  'pages.cardManage.manual.basicInfo': 'Basic Information',
  'pages.cardManage.manual.providerCode': 'Provider',
  'pages.cardManage.manual.providerCode.placeholder': 'e.g. ispay, stripe',
  'pages.cardManage.manual.upstreamProductId': 'Upstream Product ID',
  'pages.cardManage.manual.upstreamProductId.placeholder':
    'Enter unique identifier',
  'pages.cardManage.upstream.column.id': 'ID',
  'pages.cardManage.upstream.column.productId': 'Upstream Product ID',
  'pages.cardManage.upstream.column.productName': 'Product Name',
  'pages.cardManage.upstream.column.provider': 'Provider',
  'pages.cardManage.upstream.column.currency': 'Currency',
  'pages.cardManage.upstream.column.cardType': 'Card Type',
  'pages.cardManage.upstream.column.cardBin': 'Card BIN',
  'pages.cardManage.upstream.column.maxQuota': 'Max Quota',
  'pages.cardManage.upstream.column.status': 'Status',
  'pages.cardManage.upstream.column.syncedAt': 'Synced At',
  'pages.cardManage.upstream.column.isImported': 'Imported',
  'pages.cardManage.upstream.column.upstreamProductId': 'Upstream ID',
  'pages.cardManage.upstream.column.cardScheme': 'Card Scheme',
  'pages.cardManage.upstream.column.upstreamTime': 'Upstream Time',
  'pages.cardManage.upstream.column.createTime': 'Created',
  'pages.cardManage.upstream.column.updateTime': 'Updated',
  'pages.cardManage.upstream.status.enabled': 'Enabled',
  'pages.cardManage.upstream.status.disabled': 'Disabled',
  'pages.cardManage.upstream.imported.yes': 'Yes',
  'pages.cardManage.upstream.imported.no': 'No',
  'pages.cardManage.upstream.cardType.virtual': 'Virtual',
  'pages.cardManage.upstream.cardType.physical': 'Physical',
  'pages.cardManage.upstream.action.import': 'Import',
  'pages.cardManage.upstream.action.imported': 'Imported',
  // Import/Edit product modal
  'pages.cardManage.import.title': 'Import Product',
  'pages.cardManage.edit.title': 'Edit Product',
  'pages.cardManage.import.subtitle': 'Import upstream product to platform',
  'pages.cardManage.import.upstreamInfo': 'Upstream Product Info',
  'pages.cardManage.import.productInfo': 'Product Info',
  'pages.cardManage.import.platformSettings': 'Platform Settings',
  'pages.cardManage.import.feeSettings': 'Fee Settings',
  'pages.cardManage.import.limitSettings': 'Limit Settings',
  'pages.cardManage.import.otherSettings': 'Other Settings',
  'pages.cardManage.import.displayNameEn': 'Name (English)',
  'pages.cardManage.import.displayNameEn.required': 'Please enter English name',
  'pages.cardManage.import.displayNameEn.placeholder':
    'Enter English product name',
  'pages.cardManage.import.displayNameZh': 'Name (Chinese)',
  'pages.cardManage.import.displayNameZh.placeholder':
    'Enter Chinese product name',
  'pages.cardManage.import.descriptionEn': 'Description (English)',
  'pages.cardManage.import.descriptionEn.placeholder':
    'Enter English description',
  'pages.cardManage.import.descriptionZh': 'Description (Chinese)',
  'pages.cardManage.import.descriptionZh.placeholder':
    'Enter Chinese description',
  'pages.cardManage.import.cardImageUrl': 'Card Image',
  'pages.cardManage.import.cardImageUrl.placeholder': 'Enter card image URL',
  'pages.cardManage.import.cardBin': 'Card BIN',
  'pages.cardManage.import.cardBin.placeholder': 'e.g. 40963608',
  'pages.cardManage.import.cardNetwork': 'Card Network',
  'pages.cardManage.import.cardNetwork.placeholder': 'Select card network',
  'pages.cardManage.import.cardNetwork.visa': 'VISA',
  'pages.cardManage.import.cardNetwork.master': 'MasterCard',
  'pages.cardManage.import.cardNetwork.unionpay': 'UnionPay',
  'pages.cardManage.import.cardType': 'Card Type',
  'pages.cardManage.import.cardType.placeholder': 'Select card type',
  'pages.cardManage.import.cardType.virtual': 'Virtual',
  'pages.cardManage.import.cardType.physical': 'Physical',
  'pages.cardManage.import.cardCurrency': 'Card Currency',
  'pages.cardManage.import.cardCurrency.placeholder': 'Select currency',
  'pages.cardManage.import.cardCurrency.USD': 'USD',
  'pages.cardManage.import.cardCurrency.EUR': 'EUR',
  'pages.cardManage.import.cardCurrency.GBP': 'GBP',
  'pages.cardManage.import.cardCurrency.CNY': 'CNY',
  'pages.cardManage.import.supportedPayments': 'Supported Platforms',
  'pages.cardManage.import.supportedPayments.placeholder':
    'Select supported platforms',
  'pages.cardManage.import.supportedPayments.alipay': 'Alipay',
  'pages.cardManage.import.supportedPayments.wechatpay': 'WeChat Pay',
  'pages.cardManage.import.supportedPayments.applepay': 'Apple Pay',
  'pages.cardManage.import.supportedPayments.googlepay': 'Google Pay',
  'pages.cardManage.import.supportedPayments.paypal': 'PayPal',
  'pages.cardManage.import.issueRegion': 'Issue Region',
  'pages.cardManage.import.issueRegion.placeholder': 'e.g. Hong Kong, USA',
  // Fee section titles
  'pages.cardManage.import.basicFeeSettings': 'Basic Fees',
  'pages.cardManage.import.transactionFeeSettings': 'Transaction Fees',
  'pages.cardManage.import.rechargeFeeSettings': 'Recharge/Withdraw Fees',
  'pages.cardManage.import.atmFeeSettings': 'ATM Fees',
  'pages.cardManage.import.otherFeeSettings': 'Other Fees',
  // Fee fields
  'pages.cardManage.import.issueFee': 'Issue Fee',
  'pages.cardManage.import.annualFee': 'Annual Fee',
  'pages.cardManage.import.monthlyFee': 'Monthly Fee',
  'pages.cardManage.import.feeShow': 'Show to User',
  'pages.cardManage.import.transactionFeeRate': 'Transaction Rate',
  'pages.cardManage.import.transactionFeeFixed': 'Transaction Fixed',
  'pages.cardManage.import.authFee': 'Auth Fee',
  'pages.cardManage.import.authFailFee': 'Auth Fail Fee',
  'pages.cardManage.import.refundFee': 'Refund Fee',
  'pages.cardManage.import.chargebackFee': 'Chargeback Fee',
  'pages.cardManage.import.rechargeFeeRate': 'Recharge Rate',
  'pages.cardManage.import.rechargeFeeRate.placeholder': 'e.g. 0.02 for 2%',
  'pages.cardManage.import.rechargeFeeRate.tooltip':
    'Recharge fee rate charged by platform to users',
  'pages.cardManage.import.withdrawFeeRate': 'Withdraw Rate',
  'pages.cardManage.import.withdrawFeeRate.tooltip':
    'Withdraw fee rate charged by platform to users',
  'pages.cardManage.import.upstreamRechargeFeeRate': 'Upstream Recharge Rate',
  'pages.cardManage.import.upstreamRechargeFeeRate.tooltip':
    'Recharge fee rate charged by upstream (ISPay) to platform',
  'pages.cardManage.import.upstreamWithdrawFeeRate': 'Upstream Withdraw Rate',
  'pages.cardManage.import.upstreamWithdrawFeeRate.tooltip':
    'Withdraw fee rate charged by upstream (ISPay) to platform',
  'pages.cardManage.import.atmWithdrawFee': 'ATM Withdraw Fee',
  'pages.cardManage.import.atmBalanceFee': 'ATM Balance Fee',
  'pages.cardManage.import.tdsFee': '3DS Fee',
  'pages.cardManage.import.smallAmountFee': 'Small Amount Fee',
  'pages.cardManage.import.specialRegionFee': 'Special Region Fee',
  'pages.cardManage.import.specialRegionFeeMin': 'Special Region Min',
  'pages.cardManage.import.crossBorderFeeRate': 'Cross-border Rate',
  'pages.cardManage.import.crossBorderFeeMin': 'Cross-border Min',
  'pages.cardManage.import.minRecharge': 'Min Recharge (USD)',
  'pages.cardManage.import.maxRecharge': 'Max Recharge (USD)',
  'pages.cardManage.import.dailyLimit': 'Daily Limit (USD)',
  'pages.cardManage.import.monthlyLimit': 'Monthly Limit (USD)',
  'pages.cardManage.import.yearlyLimit': 'Yearly Limit (USD)',
  'pages.cardManage.import.maxOpenCardCount': 'Max Open Cards',
  'pages.cardManage.import.maxOpenCardCount.hint': 'Maximum cards per user',
  'pages.cardManage.import.validityYears': 'Validity (Years)',
  'pages.cardManage.import.validityYears.hint': 'Card validity period in years',
  'pages.cardManage.import.isActive': 'Activate Now',
  'pages.cardManage.import.isRecommended': 'Recommended',
  'pages.cardManage.import.autoIssue': 'Auto Issue',
  'pages.cardManage.import.autoIssue.tooltip':
    'When enabled, card issuance is automatically initiated after payment; otherwise admin review is required',
  'pages.cardManage.import.sortOrder': 'Sort Order',
  'pages.cardManage.import.sortOrder.hint': 'Smaller number appears first',
  'pages.cardManage.import.success': 'Product imported successfully',
  'pages.cardManage.import.failed': 'Failed to import product',
  'pages.cardManage.edit.success': 'Product updated successfully',
  'pages.cardManage.edit.failed': 'Failed to update product',
  'pages.cardManage.import.submit': 'Confirm Import',
  'pages.cardManage.edit.submit': 'Save Changes',
  'pages.cardManage.import.cancel': 'Cancel',

  // Account settings page
  'pages.account.settings.menu.base': 'Basic Settings',
  'pages.account.settings.menu.security': 'Security Settings',
  'pages.account.settings.menu.apikeys': 'API Key',

  // Basic settings
  'pages.account.settings.userId': 'User ID',
  'pages.account.settings.username': 'Username',
  'pages.account.settings.email': 'Email',
  'pages.account.settings.email.hint':
    'Email can be changed in Security Settings',
  'pages.account.settings.nickname': 'Nickname',
  'pages.account.settings.nickname.required': 'Please enter your nickname!',
  'pages.account.settings.nickname.maxLength':
    'Nickname cannot exceed 50 characters',
  'pages.account.settings.nickname.placeholder': 'Enter nickname',
  'pages.account.settings.submit': 'Update Profile',
  'pages.account.settings.updateSuccess': 'Profile updated successfully',
  'pages.account.settings.updateFailed': 'Failed to update profile',

  // Avatar upload
  'pages.account.settings.avatar.title': 'Avatar',
  'pages.account.settings.avatar.upload': 'Upload Avatar',
  'pages.account.settings.avatar.typeError': 'Only image files are allowed!',
  'pages.account.settings.avatar.sizeError': 'Image size cannot exceed 10MB!',
  'pages.account.settings.avatar.uploadSuccess': 'Avatar uploaded successfully',
  'pages.account.settings.avatar.uploadFailed': 'Failed to upload avatar',

  // Security settings
  'pages.account.settings.security.password': 'Password',
  'pages.account.settings.security.password.desc':
    'Changing password regularly can improve account security',
  'pages.account.settings.security.modify': 'Modify',
  'pages.account.settings.security.email': 'Bound Email',
  'pages.account.settings.security.email.bound': 'Bound email',
  'pages.account.settings.security.email.notBound': 'No email bound',
  'pages.account.settings.security.change': 'Change',
  'pages.account.settings.security.bind': 'Bind',

  // Change password
  'pages.account.settings.password.title': 'Change Password',
  'pages.account.settings.password.old': 'Current Password',
  'pages.account.settings.password.old.required':
    'Please enter current password',
  'pages.account.settings.password.old.placeholder': 'Enter current password',
  'pages.account.settings.password.new': 'New Password',
  'pages.account.settings.password.new.required': 'Please enter new password',
  'pages.account.settings.password.new.minLength':
    'Password must be at least 6 characters',
  'pages.account.settings.password.new.placeholder': 'Enter new password',
  'pages.account.settings.password.confirm': 'Confirm New Password',
  'pages.account.settings.password.confirm.required':
    'Please confirm new password',
  'pages.account.settings.password.confirm.placeholder':
    'Re-enter new password',
  'pages.account.settings.password.mismatch': 'Passwords do not match',
  'pages.account.settings.password.submit': 'Confirm Change',
  'pages.account.settings.password.success': 'Password changed successfully',
  'pages.account.settings.password.failed': 'Failed to change password',

  // Change email
  'pages.account.settings.email.changeTitle': 'Change Email',
  'pages.account.settings.email.bindTitle': 'Bind Email',
  'pages.account.settings.email.step1': 'Verify Current Email',
  'pages.account.settings.email.step2': 'Bind New Email',
  'pages.account.settings.email.currentEmail': 'Current Email',
  'pages.account.settings.email.newEmail': 'New Email',
  'pages.account.settings.email.newEmail.required': 'Please enter new email',
  'pages.account.settings.email.newEmail.invalid': 'Invalid email format',
  'pages.account.settings.email.newEmail.placeholder':
    'Enter new email address',
  'pages.account.settings.email.code.required':
    'Please enter verification code',
  'pages.account.settings.email.code.length':
    'Verification code must be 6 digits',
  'pages.account.settings.email.code.placeholder': '6-digit code',
  'pages.account.settings.email.sendCode': 'Send Code',
  'pages.account.settings.email.codeSent': 'Verification code sent',
  'pages.account.settings.email.sendFailed': 'Failed to send verification code',
  'pages.account.settings.email.verifyNext': 'Verify & Continue',
  'pages.account.settings.email.currentVerified': 'Current email verified',
  'pages.account.settings.email.currentVerifiedTip':
    'Current email verified. Please bind new email within 30 minutes',
  'pages.account.settings.email.verifyFailed': 'Verification failed',
  'pages.account.settings.email.inputNewEmail': 'Please enter new email first',
  'pages.account.settings.email.confirmBind': 'Confirm Bind',
  'pages.account.settings.email.bindSuccess': 'Email bound successfully',
  'pages.account.settings.email.bindFailed': 'Failed to bind email',

  // API Key Management
  'pages.account.settings.apiKey.title': 'API Key Management',
  'pages.account.settings.apiKey.description':
    'API Keys are used for programmatic access to your account. Each user can create up to 5 active keys. Please keep your Secret safe, it is only displayed once when created.',
  'pages.account.settings.apiKey.create': 'Create API Key',
  'pages.account.settings.apiKey.empty': 'No API Keys',
  'pages.account.settings.apiKey.loadFailed': 'Failed to load',
  'pages.account.settings.apiKey.createSuccess': 'Created successfully',
  'pages.account.settings.apiKey.createFailed': 'Failed to create',
  'pages.account.settings.apiKey.revokeSuccess': 'Revoked successfully',
  'pages.account.settings.apiKey.revokeFailed': 'Failed to revoke',
  'pages.account.settings.apiKey.revokeConfirm':
    'Are you sure you want to revoke this API Key?',
  'pages.account.settings.apiKey.revoke': 'Revoke',
  'pages.account.settings.apiKey.copied': 'Copied',
  'pages.account.settings.apiKey.copy': 'Copy',
  'pages.account.settings.apiKey.confirm': 'Confirm',
  'pages.account.settings.apiKey.cancel': 'Cancel',
  'pages.account.settings.apiKey.understood': 'I have saved it, close',
  'pages.account.settings.apiKey.secretWarning':
    'Please save the following information immediately, Secret is only displayed once!',
  'pages.account.settings.apiKey.column.name': 'Name',
  'pages.account.settings.apiKey.column.permissions': 'Permissions',
  'pages.account.settings.apiKey.column.status': 'Status',
  'pages.account.settings.apiKey.column.lastUsed': 'Last Used',
  'pages.account.settings.apiKey.column.action': 'Action',
  'pages.account.settings.apiKey.status.active': 'Active',
  'pages.account.settings.apiKey.status.revoked': 'Revoked',
  'pages.account.settings.apiKey.permission.trade': 'Trade',
  'pages.account.settings.apiKey.permission.trade.desc':
    'Create and cancel orders',
  'pages.account.settings.apiKey.permission.withdraw': 'Withdraw',
  'pages.account.settings.apiKey.permission.withdraw.desc':
    'Initiate withdrawal requests (high risk)',
  'pages.account.settings.apiKey.permission.read': 'Read Only',
  'pages.account.settings.apiKey.permission.read.desc':
    'View account info, balance, orders',
  'pages.account.settings.apiKey.form.name': 'Name',
  'pages.account.settings.apiKey.form.name.required': 'Please enter a name',
  'pages.account.settings.apiKey.form.name.maxLength':
    'Name cannot exceed 50 characters',
  'pages.account.settings.apiKey.form.name.placeholder': 'e.g., Trading Bot',
  'pages.account.settings.apiKey.form.permissions': 'Permissions',
  'pages.account.settings.apiKey.form.permissions.required':
    'Please select at least one permission',

  // Session Management
  'pages.account.settings.menu.sessions': 'Sessions',
  'pages.account.settings.sessions.title': 'Session Management',
  'pages.account.settings.sessions.description':
    'Manage your logged-in devices. You can log out suspicious devices at any time to protect your account.',
  'pages.account.settings.sessions.historyDescription':
    'View your login history. Records are retained for 90 days.',
  'pages.account.settings.sessions.tab.devices': 'Devices',
  'pages.account.settings.sessions.tab.history': 'Login History',
  'pages.account.settings.sessions.loadFailed': 'Failed to load',
  'pages.account.settings.sessions.empty': 'No sessions',
  'pages.account.settings.sessions.historyEmpty': 'No login records',
  'pages.account.settings.sessions.total': '{total} device(s)',
  'pages.account.settings.sessions.historyTotal': '{total} record(s)',
  'pages.account.settings.sessions.currentDevice': 'Current',
  'pages.account.settings.sessions.revokeOthers': 'Log Out All Other Devices',
  'pages.account.settings.sessions.revokeOthersConfirmTitle':
    'Log Out All Other Devices',
  'pages.account.settings.sessions.revokeOthersConfirmContent':
    'Are you sure you want to log out all other devices? This action cannot be undone.',
  'pages.account.settings.sessions.revokeOthersSuccess':
    '{count} device(s) logged out',
  'pages.account.settings.sessions.revokeOthersFailed': 'Failed to log out',
  'pages.account.settings.sessions.revokeConfirm':
    'Are you sure you want to log out this device?',
  'pages.account.settings.sessions.revokeSuccess': 'Device logged out',
  'pages.account.settings.sessions.revokeFailed': 'Failed to log out',
  'pages.account.settings.sessions.revoke': 'Log Out',
  'pages.account.settings.sessions.confirm': 'Confirm',
  'pages.account.settings.sessions.cancel': 'Cancel',
  'pages.account.settings.sessions.search': 'Search',
  'pages.account.settings.sessions.filterStatus': 'Filter Status',
  'pages.account.settings.sessions.column.device': 'Device',
  'pages.account.settings.sessions.column.location': 'Location',
  'pages.account.settings.sessions.column.loginMethod': 'Login Method',
  'pages.account.settings.sessions.column.lastActive': 'Last Active',
  'pages.account.settings.sessions.column.action': 'Action',
  'pages.account.settings.sessions.column.time': 'Time',
  'pages.account.settings.sessions.column.status': 'Status',
  'pages.account.settings.sessions.device.desktop': 'Desktop',
  'pages.account.settings.sessions.device.mobile': 'Mobile',
  'pages.account.settings.sessions.device.tablet': 'Tablet',
  'pages.account.settings.sessions.device.unknown': 'Unknown',
  'pages.account.settings.sessions.loginMethod.password': 'Password',
  'pages.account.settings.sessions.loginMethod.google': 'Google',
  'pages.account.settings.sessions.loginMethod.apikey': 'API Key',
  'pages.account.settings.sessions.status.success': 'Success',
  'pages.account.settings.sessions.status.failed': 'Failed',

  // Wallet Records page
  'pages.wallet.records.title': 'Transaction Records',
  'pages.wallet.stats.depositPending': 'Deposits Pending',
  'pages.wallet.stats.withdrawPending': 'Withdrawals Pending',
  'pages.wallet.stats.failed': 'Failed Tasks',
  'pages.wallet.stats.unmatched': 'Unmatched Addresses',
  'pages.wallet.tab.all': 'All',
  'pages.wallet.tab.deposit': 'Deposits',
  'pages.wallet.tab.withdraw': 'Withdrawals',
  'pages.wallet.tab.failed': 'Failed',
  'pages.wallet.tab.unmatched': 'Unmatched',
  'pages.wallet.column.userId': 'User ID',
  'pages.wallet.column.type': 'Type',
  'pages.wallet.column.symbol': 'Symbol',
  'pages.wallet.column.amount': 'Amount',
  'pages.wallet.column.chain': 'Chain',
  'pages.wallet.column.address': 'Address',
  'pages.wallet.column.status': 'Status',
  'pages.wallet.column.createdAt': 'Created At',
  'pages.wallet.column.error': 'Error Message',
  'pages.wallet.type.deposit': 'Deposit',
  'pages.wallet.type.withdraw': 'Withdraw',
  'pages.wallet.status.pending': 'Pending',
  'pages.wallet.status.completed': 'Completed',
  'pages.wallet.status.failed': 'Failed',
  'pages.wallet.error.fetchFailed': 'Failed to fetch data',

  // History page
  'pages.wallet.history.title': 'History',
  'pages.wallet.history.type.all': 'All',
  'pages.wallet.history.type.deposit': 'Deposit',
  'pages.wallet.history.type.withdrawal': 'Withdrawal',
  'pages.wallet.history.type.swap': 'Swap',
  'pages.wallet.history.type.pay': 'Pay',
  'pages.wallet.history.type.refund': 'Refund',
  'pages.wallet.history.type.internal_transfer': 'Internal Transfer',
  'pages.wallet.history.type.internal_deposit': 'Balance Adjustment',
  'pages.wallet.history.type.card_issue': 'Card Issue',
  'pages.wallet.history.type.card_recharge': 'Card Recharge',
  'pages.wallet.history.type.card_withdraw': 'Card Withdraw',
  'pages.wallet.history.type.referral_reward': 'Referral Reward',
  'pages.wallet.history.type.deposit.short': 'Deposit',
  'pages.wallet.history.type.withdrawal.short': 'Withdraw',
  'pages.wallet.history.type.swap.short': 'Swap',
  'pages.wallet.history.type.pay.short': 'Pay',
  'pages.wallet.history.type.refund.short': 'Refund',
  'pages.wallet.history.type.internal_transfer.short': 'Transfer',
  'pages.wallet.history.type.internal_deposit.short': 'Adjust',
  'pages.wallet.history.type.card_issue.short': 'Issue',
  'pages.wallet.history.type.card_recharge.short': 'Card In',
  'pages.wallet.history.type.card_withdraw.short': 'Card Out',
  'pages.wallet.history.type.referral_reward.short': 'Reward',
  'pages.wallet.history.column.description': 'Description',
  'pages.wallet.history.filter.userId': 'User ID',
  'pages.wallet.history.filter.type': 'Type',
  'pages.wallet.history.filter.symbol': 'Symbol (e.g. USDT)',

  // My Assets page
  'pages.assets.balances.title': 'My Assets',
  'pages.assets.addresses.title': 'Deposit Addresses',
  'pages.assets.deposit.title': 'Deposit',
  'pages.assets.deposit.subtitle': 'Select currency and network to deposit',
  'pages.assets.deposit.selectCurrency': 'Currency',
  'pages.assets.deposit.selectNetwork': 'Network',
  'pages.assets.deposit.warning.desc':
    'Only send {symbol} via {network}. Sending other assets will result in loss.',
  'pages.assets.deposit.noAddress': 'No address found',
  'pages.assets.deposit.noAssets': 'No assets available',
  'pages.assets.history.title': 'Transaction History',
  'pages.assets.refresh': 'Refresh',
  'pages.assets.frozen': 'Frozen',
  'pages.assets.noBalances': 'No assets',
  'pages.assets.noDigitalAssets': 'No digital assets yet',
  'pages.assets.noFiatAssets': 'No fiat assets yet',
  'pages.assets.noAddresses': 'No deposit addresses',
  'pages.assets.networks': 'networks',
  'pages.assets.copy': 'Copy',
  'pages.assets.copied': 'Copied',
  'pages.assets.copyFailed': 'Failed to copy',
  'pages.assets.tab.all': 'All',
  'pages.assets.tab.deposit': 'Deposits',
  'pages.assets.tab.withdraw': 'Withdrawals',
  'pages.assets.column.type': 'Type',
  'pages.assets.column.symbol': 'Currency',
  'pages.assets.column.amount': 'Amount',
  'pages.assets.column.chain': 'Chain',
  'pages.assets.column.address': 'Address',
  'pages.assets.column.status': 'Status',
  'pages.assets.column.createdAt': 'Time',
  'pages.assets.type.deposit': 'Deposit',
  'pages.assets.type.withdraw': 'Withdraw',
  'pages.assets.type.withdrawal': 'Withdrawal',
  'pages.assets.type.swap': 'Swap',
  'pages.assets.type.pay': 'Pay',
  'pages.assets.type.refund': 'Refund',
  'pages.assets.type.internal_transfer': 'Transfer',
  'pages.assets.type.internal_deposit': 'Adjustment',
  'pages.assets.type.card_issue': 'Card Issue',
  'pages.assets.type.card_recharge': 'Card Recharge',
  'pages.assets.type.card_withdraw': 'Card Withdraw',
  'pages.assets.type.referral_reward': 'Referral Reward',
  'pages.assets.status.pending': 'Pending',
  'pages.assets.status.completed': 'Completed',
  'pages.assets.status.failed': 'Failed',
  'pages.assets.error.loadBalances': 'Failed to load balances',
  'pages.assets.error.loadAddresses': 'Failed to load deposit addresses',
  'pages.assets.error.loadHistory': 'Failed to load transaction history',

  // Card Application page
  'pages.myCards.refresh': 'Refresh',
  'pages.myCards.empty': 'No card products available',
  'pages.myCards.error.load': 'Failed to load card products',
  'pages.myCards.recommended': 'Recommended',
  'pages.myCards.type.virtual': 'Virtual',
  'pages.myCards.type.physical': 'Physical',
  'pages.myCards.years': 'years',
  // List columns
  'pages.myCards.column.cardImage': 'Card',
  'pages.myCards.column.name': 'Product Name',
  'pages.myCards.column.type': 'Type',
  'pages.myCards.column.cardBin': 'Card BIN',
  'pages.myCards.column.currency': 'Currency',
  'pages.myCards.column.issueFee': 'Issue Fee',
  'pages.myCards.column.annualFee': 'Annual Fee',
  'pages.myCards.column.transactionFee': 'Transaction Fee',
  'pages.myCards.column.limits': 'Limits',
  'pages.myCards.column.action': 'Action',
  'pages.myCards.action.detail': 'Detail',
  // Fees
  'pages.myCards.fee.issue': 'Issue Fee',
  'pages.myCards.fee.annual': 'Annual Fee',
  'pages.myCards.fee.monthly': 'Monthly Fee',
  'pages.myCards.fee.transaction': 'Transaction Fee',
  'pages.myCards.fee.auth': 'Auth Fee',
  'pages.myCards.fee.refund': 'Refund Fee',
  'pages.myCards.fee.atm': 'ATM Withdraw Fee',
  'pages.myCards.fee.crossBorder': 'Cross Border Fee',
  'pages.myCards.fee.chargeback': 'Chargeback Fee',
  'pages.myCards.fee.rechargeRate': 'Recharge Fee Rate',
  'pages.myCards.fee.withdrawRate': 'Withdraw Fee Rate',
  // Detail modal
  'pages.myCards.detail.basic': 'Basic Info',
  'pages.myCards.detail.network': 'Card Network',
  'pages.myCards.detail.cardBin': 'Card BIN',
  'pages.myCards.detail.type': 'Card Type',
  'pages.myCards.detail.currency': 'Currency',
  'pages.myCards.detail.region': 'Issue Region',
  'pages.myCards.detail.validity': 'Validity',
  'pages.myCards.detail.maxCards': 'Max Cards',
  'pages.myCards.detail.payments': 'Supported Payments',
  'pages.myCards.detail.limits': 'Limits',
  'pages.myCards.detail.minRecharge': 'Min Recharge',
  'pages.myCards.detail.maxRecharge': 'Max Recharge',
  'pages.myCards.detail.dailyLimit': 'Daily Limit',
  'pages.myCards.detail.monthlyLimit': 'Monthly Limit',
  'pages.myCards.detail.yearlyLimit': 'Yearly Limit',
  'pages.myCards.detail.fees': 'Fees',
  // Tab labels
  'pages.myCards.tab.cardHolder': 'Card Holders',
  'pages.myCards.tab.applications': 'My Applications',
  'pages.myCards.tab.cardProducts': 'Card Products',
  'pages.myCards.action.apply': 'Apply',

  // Apply Card Modal
  'pages.cardApply.title': 'Apply for Card',
  'pages.cardApply.productInfo': 'Card Product',
  'pages.cardApply.productName': 'Product Name',
  'pages.cardApply.selectKyc': 'Select Card Holder',
  'pages.cardApply.selectKyc.required': 'Please select a card holder',
  'pages.cardApply.selectKyc.placeholder': 'Select an approved KYC identity',
  'pages.cardApply.selectKyc.placeholder.optional':
    'Select KYC identity (optional)',
  'pages.cardApply.selectKyc.optionalHint':
    'KYC is optional for physical cards',
  'pages.cardApply.hint':
    'The issue fee will be deducted from your USD balance after submission.',
  'pages.cardApply.hint.physical':
    'Physical card will be shipped to your address after payment. Please fill in the correct shipping address.',
  'pages.cardApply.submit': 'Submit Application',
  'pages.cardApply.success': 'Application submitted! No.: {no}',
  'pages.cardApply.failed': 'Application failed',
  'pages.cardApply.noKyc': 'No approved KYC identity found',
  'pages.cardApply.noKyc.desc':
    'Please complete KYC verification first in the "Card Holders" tab.',
  // Physical card shipping address
  'pages.cardApply.shippingAddress': 'Shipping Address',
  'pages.cardApply.recipientName': 'Recipient Name',
  'pages.cardApply.recipientName.placeholder': 'Enter recipient name',
  'pages.cardApply.recipientName.required': 'Please enter recipient name',
  'pages.cardApply.recipientPhone': 'Phone Number',
  'pages.cardApply.recipientPhone.placeholder': 'Enter phone number',
  'pages.cardApply.recipientPhone.required': 'Please enter phone number',
  'pages.cardApply.country': 'Country',
  'pages.cardApply.country.placeholder': 'Enter country',
  'pages.cardApply.country.required': 'Please enter country',
  'pages.cardApply.province': 'Province/State',
  'pages.cardApply.province.placeholder': 'Optional',
  'pages.cardApply.city': 'City',
  'pages.cardApply.city.placeholder': 'Optional',
  'pages.cardApply.address': 'Address',
  'pages.cardApply.address.placeholder': 'Enter detailed address',
  'pages.cardApply.address.required': 'Please enter address',
  'pages.cardApply.postalCode': 'Postal Code',
  'pages.cardApply.postalCode.placeholder': 'Optional',

  // My Applications List
  'pages.application.column.applicationNo': 'Application No.',
  'pages.application.column.cardName': 'Card Product',
  'pages.application.column.cardBin': 'Card BIN',
  'pages.application.column.issueFee': 'Issue Fee',
  'pages.application.column.status': 'Status',
  'pages.application.column.cardInfo': 'Card Info',
  'pages.application.column.createdAt': 'Created At',
  'pages.application.column.action': 'Action',
  'pages.application.action.detail': 'Detail',
  'pages.application.error.loadDetail': 'Failed to load application detail',
  'pages.application.status.pending': 'Pending',
  'pages.application.status.kycFailed': 'KYC Failed',
  'pages.application.status.paymentFailed': 'Payment Failed',
  'pages.application.status.paid': 'Paid',
  'pages.application.status.processing': 'Processing',
  'pages.application.status.shipped': 'Shipped',
  'pages.application.status.pendingAssign': 'Pending Assign',
  'pages.application.status.assignFailed': 'Assign Failed',
  'pages.application.status.assigned': 'Pending Activation',
  'pages.application.status.pendingActivation': 'Pending Activation',
  'pages.application.status.activateFailed': 'Activate Failed',
  'pages.application.status.success': 'Success',
  'pages.application.status.failed': 'Failed',
  'pages.application.status.cancelled': 'Cancelled',

  // Retry related
  'pages.application.retry.payment.title': 'Retry Payment',
  'pages.application.retry.payment.hint':
    'Payment failed. Please ensure you have sufficient balance and try again.',
  'pages.application.retry.payment.button': 'Retry Payment',
  'pages.application.retry.payment.success': 'Payment retry successful',
  'pages.application.retry.payment.failed': 'Payment retry failed',
  'pages.application.retry.kyc.title': 'Retry KYC Verification',
  'pages.application.retry.kyc.hint':
    'KYC verification failed. Please select a different approved KYC identity to retry.',
  'pages.application.retry.kyc.button': 'Retry with New KYC',
  'pages.application.retry.kyc.success': 'KYC retry successful',
  'pages.application.retry.kyc.failed': 'KYC retry failed',
  'pages.application.retry.kyc.selectKyc': 'Select New KYC Identity',
  'pages.application.retry.kyc.selectKyc.required':
    'Please select a KYC identity',
  'pages.application.retry.kyc.selectKyc.placeholder':
    'Select an approved KYC identity',
  'pages.application.retry.kyc.noKyc': 'No approved KYC identity found',
  'pages.application.retry.kyc.noKyc.desc':
    'Please complete KYC verification first in the "Card Holders" tab.',

  // Physical card assign/activate retry
  'pages.physicalCard.assign.retry.title': 'Retry Card Assignment',
  'pages.physicalCard.assign.retry.hint':
    'Previous assignment failed. Please check your card number and try again.',
  'pages.physicalCard.activate.retry.title': 'Retry Card Activation',
  'pages.physicalCard.activate.retry.hint':
    'Previous activation failed. Please check your activation code and PIN, then try again.',

  // Application Detail Modal
  'pages.application.detail.title': 'Application Detail',
  'pages.application.detail.info': 'Application Info',
  'pages.application.detail.applicationNo': 'Application No.',
  'pages.application.detail.status': 'Status',
  'pages.application.detail.cardProduct': 'Card Product',
  'pages.application.detail.statusMessage': 'Status Message',
  'pages.application.detail.feeInfo': 'Fee Info',
  'pages.application.detail.issueFee': 'Issue Fee',
  'pages.application.detail.currency': 'Currency',
  'pages.application.detail.cardInfo': 'Card Info',
  'pages.application.detail.cardNumber': 'Card Number',
  'pages.application.detail.cardHolder': 'Card Holder',
  'pages.application.detail.timeline': 'Timeline',
  'pages.application.detail.createdAt': 'Created At',
  'pages.application.detail.paidAt': 'Paid At',
  'pages.application.detail.completedAt': 'Completed At',
  'pages.application.detail.cardType': 'Card Type',
  'pages.application.detail.shippingAddress': 'Shipping Address',
  'pages.application.detail.recipientName': 'Recipient',
  'pages.application.detail.recipientPhone': 'Phone',
  'pages.application.detail.country': 'Country',
  'pages.application.detail.province': 'Province/State',
  'pages.application.detail.city': 'City',
  'pages.application.detail.address': 'Address',
  'pages.application.detail.postalCode': 'Postal Code',
  'pages.application.detail.shippingInfo': 'Shipping Info',
  'pages.application.detail.shippingCompany': 'Shipping Company',
  'pages.application.detail.trackingNumber': 'Tracking Number',
  'pages.application.detail.shippedAt': 'Shipped At',
  'pages.application.step.submit': 'Submit',
  'pages.application.step.submitDesc': 'Application submitted',
  'pages.application.step.payment': 'Payment',
  'pages.application.step.paymentDesc': 'Fee deducted',
  'pages.application.step.processing': 'Processing',
  'pages.application.step.processingDesc': 'Card issuing',
  'pages.application.step.shipping': 'Shipping',
  'pages.application.step.shippingDesc': 'Card shipping',
  'pages.application.step.complete': 'Complete',
  'pages.application.step.completeDesc': 'Card ready',

  // Card Holder Management
  'pages.cardHolder.column.name': 'Name',
  'pages.cardHolder.column.country': 'Country',
  'pages.cardHolder.column.level': 'Level',
  'pages.cardHolder.column.status': 'Status',
  'pages.cardHolder.column.createdAt': 'Created At',
  'pages.cardHolder.column.action': 'Action',
  'pages.cardHolder.status.approved': 'Approved',
  'pages.cardHolder.status.rejected': 'Rejected',
  'pages.cardHolder.status.pending': 'Pending',
  'pages.cardHolder.action.view': 'View',
  'pages.cardHolder.action.resubmit': 'Resubmit',
  'pages.cardHolder.action.create': 'Add Card Holder',
  'pages.cardHolder.error.loadDetail': 'Failed to load details',
  // Card Holder Details
  'pages.cardHolder.detail.title': 'Card Holder Details',
  'pages.cardHolder.detail.status': 'Status',
  'pages.cardHolder.detail.name': 'Name',
  'pages.cardHolder.detail.gender': 'Gender',
  'pages.cardHolder.detail.birthday': 'Birthday',
  'pages.cardHolder.detail.country': 'Country',
  'pages.cardHolder.detail.email': 'Email',
  'pages.cardHolder.detail.phone': 'Phone',
  'pages.cardHolder.detail.address': 'Address',
  'pages.cardHolder.detail.postCode': 'Post Code',
  'pages.cardHolder.detail.idType': 'ID Type',
  'pages.cardHolder.detail.idNumber': 'ID Number',
  'pages.cardHolder.detail.idPhotos': 'ID Photos',
  'pages.cardHolder.detail.idFront': 'Front',
  'pages.cardHolder.detail.idBack': 'Back',
  'pages.cardHolder.detail.rejectReason': 'Reject Reason',
  'pages.cardHolder.gender.male': 'Male',
  'pages.cardHolder.gender.female': 'Female',
  'pages.cardHolder.idType.passport': 'Passport',
  'pages.cardHolder.idType.idCard': 'ID Card',
  // Card Holder Form
  'pages.cardHolder.form.createTitle': 'Add Card Holder',
  'pages.cardHolder.form.editTitle': 'Resubmit KYC',
  'pages.cardHolder.form.firstName': 'First Name',
  'pages.cardHolder.form.firstName.placeholder': 'Enter first name',
  'pages.cardHolder.form.lastName': 'Last Name',
  'pages.cardHolder.form.lastName.placeholder': 'Enter last name',
  'pages.cardHolder.form.name.englishOnly':
    'Please use English letters only (or Pinyin)',
  'pages.cardHolder.form.name.hint':
    'English letters only. Chinese users please use Pinyin (e.g., Zhang San)',
  'pages.cardHolder.form.gender': 'Gender',
  'pages.cardHolder.form.birthday': 'Birthday',
  'pages.cardHolder.form.email': 'Email',
  'pages.cardHolder.form.email.placeholder': 'Enter email',
  'pages.cardHolder.form.email.invalid': 'Please enter a valid email',
  'pages.cardHolder.form.mobilePrefix': 'Prefix',
  'pages.cardHolder.form.phone': 'Phone',
  'pages.cardHolder.form.phone.placeholder': 'Enter phone number',
  'pages.cardHolder.form.phone.digitsOnly':
    'Phone number must contain only digits',
  'pages.cardHolder.form.country': 'Country',
  'pages.cardHolder.form.province': 'Province',
  'pages.cardHolder.form.province.placeholder': 'Enter province',
  'pages.cardHolder.form.city': 'City',
  'pages.cardHolder.form.city.placeholder': 'Enter city',
  'pages.cardHolder.form.area': 'Area',
  'pages.cardHolder.form.area.placeholder': 'Enter area',
  'pages.cardHolder.form.postCode': 'Post Code',
  'pages.cardHolder.form.postCode.placeholder': 'Enter post code',
  'pages.cardHolder.form.address': 'Address',
  'pages.cardHolder.form.address.placeholder': 'Enter detailed address',
  'pages.cardHolder.form.idType': 'ID Type',
  'pages.cardHolder.form.idNumber': 'ID Number',
  'pages.cardHolder.form.idNumber.placeholder': 'Enter ID number',
  'pages.cardHolder.form.idFront': 'ID Front Photo',
  'pages.cardHolder.form.idBack': 'ID Back Photo',
  'pages.cardHolder.form.idFront.required': 'Please upload ID front photo',
  'pages.cardHolder.form.idBack.required': 'Please upload ID back photo',
  'pages.cardHolder.form.optional': 'Optional',
  'pages.cardHolder.form.uploaded': 'Uploaded',
  'pages.cardHolder.form.upload.front': 'Upload Front',
  'pages.cardHolder.form.upload.back': 'Upload Back',
  'pages.cardHolder.form.upload.reupload': 'Re-upload',
  'pages.cardHolder.form.upload.typeError': 'Only image files are allowed!',
  'pages.cardHolder.form.upload.sizeError': 'Image size cannot exceed 10MB!',
  'pages.cardHolder.form.upload.success': 'Upload successful',
  'pages.cardHolder.form.upload.failed': 'Upload failed',
  'pages.cardHolder.form.createSuccess': 'Created successfully',
  'pages.cardHolder.form.resubmitSuccess': 'Resubmitted successfully',
  'pages.cardHolder.form.submitFailed': 'Submit failed',

  // User Cards Page
  'pages.userCards.title': 'My Cards',
  'pages.userCards.list.title': 'Card List',
  'pages.userCards.refresh': 'Refresh',
  'pages.userCards.empty': 'No cards yet',
  'pages.userCards.error.load': 'Failed to load cards',
  // Stats
  'pages.userCards.stats.total': 'Total Cards',
  'pages.userCards.stats.activeCards': 'Active Cards',
  'pages.userCards.stats.totalBalance': 'Total Balance',
  // Card Status
  'pages.userCards.status': 'Status',
  'pages.userCards.status.active': 'Active',
  'pages.userCards.status.assigned': 'Pending Activation',
  'pages.userCards.status.frozen': 'Frozen',
  'pages.userCards.status.cancelled': 'Cancelled',
  'pages.userCards.status.expired': 'Expired',
  // Card Fields
  'pages.userCards.cardNumber': 'Card Number',
  'pages.userCards.holderName': 'Card Holder',
  'pages.userCards.expireDate': 'Expires',
  'pages.userCards.balance': 'Balance',
  // Actions
  'pages.userCards.action': 'Actions',
  'pages.userCards.action.detail': 'Detail',
  'pages.userCards.action.recharge': 'Recharge',
  'pages.userCards.action.transactions': 'History',
  // Card Detail Modal
  'pages.userCards.detail.title': 'Card Details',
  'pages.userCards.detail.loading': 'Loading...',
  'pages.userCards.detail.error': 'Failed to load details',
  'pages.userCards.detail.basicInfo': 'Basic Info',
  'pages.userCards.detail.sensitiveInfo': 'Sensitive Info',
  'pages.userCards.detail.showSensitive': 'Show Sensitive Info',
  'pages.userCards.detail.hideSensitive': 'Hide Sensitive Info',
  'pages.userCards.detail.cardOrg': 'Card Org',
  'pages.userCards.detail.cardBin': 'Card BIN',
  'pages.userCards.detail.createdAt': 'Created At',
  'pages.userCards.detail.cardNumber': 'Full Card Number',
  'pages.userCards.detail.cvv': 'CVV',
  'pages.userCards.detail.pin': 'PIN',
  'pages.userCards.detail.copy': 'Copy',
  'pages.userCards.detail.copySuccess': 'Copied',
  // Recharge Modal
  'pages.userCards.recharge.title': 'Recharge Card',
  'pages.userCards.recharge.targetCard': 'Target Card',
  'pages.userCards.recharge.currentBalance': 'Current Balance',
  'pages.userCards.recharge.amount': 'Amount',
  'pages.userCards.recharge.amount.placeholder': 'Enter recharge amount',
  'pages.userCards.recharge.amount.required': 'Please enter recharge amount',
  'pages.userCards.recharge.amount.min': 'Amount must be greater than 0',
  'pages.userCards.recharge.hint':
    'Recharge will be deducted from your USD account balance',
  'pages.userCards.recharge.success': 'Recharge successful',
  'pages.userCards.recharge.processing':
    'Recharge processing, please check later',
  'pages.userCards.recharge.error': 'Recharge failed',
  'pages.userCards.recharge.newBalance': 'New Balance',
  'pages.userCards.recharge.transactionNo': 'Transaction No',
  // Transactions Modal
  'pages.userCards.transactions.title': 'Transaction History',
  'pages.userCards.transactions.error.load': 'Failed to load transactions',
  'pages.userCards.transactions.total': 'Total {total} records',
  'pages.userCards.transactions.column.time': 'Time',
  'pages.userCards.transactions.column.type': 'Type',
  'pages.userCards.transactions.column.amount': 'Amount',
  'pages.userCards.transactions.column.fee': 'Fee',
  'pages.userCards.transactions.column.balance': 'Balance',
  'pages.userCards.transactions.column.status': 'Status',
  'pages.userCards.transactions.column.transactionNo': 'Transaction No',
  'pages.userCards.transactions.before': 'Before',
  'pages.userCards.transactions.after': 'After',
  // Transaction Types
  'pages.userCards.transactions.type.recharge': 'Recharge',
  'pages.userCards.transactions.type.consume': 'Consume',
  'pages.userCards.transactions.type.refund': 'Refund',
  'pages.userCards.transactions.type.withdraw': 'Withdraw',
  'pages.userCards.transactions.type.fee': 'Fee',
  // Transaction Status
  'pages.userCards.transactions.status.pending': 'Pending',
  'pages.userCards.transactions.status.success': 'Success',
  'pages.userCards.transactions.status.failed': 'Failed',

  // Withdraw
  'pages.userCards.action.withdraw': 'Withdraw',
  'pages.userCards.withdraw.title': 'Card Withdraw',
  'pages.userCards.withdraw.submit': 'Confirm Withdraw',
  'pages.userCards.withdraw.hint':
    'The withdraw amount will be credited to your USD wallet balance.',
  'pages.userCards.withdraw.amount': 'Withdraw Amount (USD)',
  'pages.userCards.withdraw.amount.placeholder': 'Enter withdraw amount',
  'pages.userCards.withdraw.amount.required': 'Please enter withdraw amount',
  'pages.userCards.withdraw.amount.min':
    'Withdraw amount must be greater than 0',
  'pages.userCards.withdraw.amount.max':
    'Withdraw amount cannot exceed card balance',
  'pages.userCards.withdraw.success': 'Withdraw successful',
  'pages.userCards.withdraw.processing':
    'Withdraw request submitted, waiting for confirmation',
  'pages.userCards.withdraw.error': 'Withdraw failed',

  // Freeze/Unfreeze
  'pages.userCards.action.manage': 'Manage',
  'pages.userCards.action.freeze': 'Freeze',
  'pages.userCards.action.unfreeze': 'Unfreeze',
  'pages.userCards.freeze.unavailable':
    'This card cannot be frozen or unfrozen',
  'pages.userCards.freeze.confirm.title': 'Freeze Card',
  'pages.userCards.freeze.confirm.desc':
    'After freezing, the card cannot be used for transactions. Are you sure?',
  'pages.userCards.unfreeze.confirm.title': 'Unfreeze Card',
  'pages.userCards.unfreeze.confirm.desc':
    'After unfreezing, the card will resume normal use. Are you sure?',
  'pages.userCards.freeze.success': 'Card frozen successfully',
  'pages.userCards.unfreeze.success': 'Card unfrozen successfully',
  'pages.userCards.freeze.error': 'Operation failed',

  // Card Detail Extended
  'pages.userCards.detail.productName': 'Product Name',
  'pages.userCards.detail.status': 'Status',
  'pages.userCards.detail.cardType': 'Card Type',
  'pages.userCards.detail.cardType.virtual': 'Virtual Card',
  'pages.userCards.detail.cardType.physical': 'Physical Card',
  'pages.userCards.detail.cardCurrency': 'Currency',
  'pages.userCards.detail.issueRegion': 'Issue Region',
  'pages.userCards.detail.supportedPayments': 'Supported Payments',
  'pages.userCards.detail.limits': 'Limits',
  'pages.userCards.detail.yearlyLimit': 'Yearly Limit',
  'pages.userCards.detail.feeRates': 'Fee Rates',
  'pages.userCards.detail.fees': 'Fee Details',
  'pages.userCards.detail.fees.issueFee': 'Issue Fee',
  'pages.userCards.detail.fees.annualFee': 'Annual Fee',
  'pages.userCards.detail.fees.monthlyFee': 'Monthly Fee',
  'pages.userCards.detail.fees.authFee': 'Auth Fee',
  'pages.userCards.detail.fees.transactionFee': 'Transaction Fee',
  'pages.userCards.detail.fees.refundFee': 'Refund Fee',
  'pages.userCards.detail.fees.atmWithdrawFee': 'ATM Withdraw Fee',
  'pages.userCards.detail.fees.atmBalanceFee': 'ATM Balance Fee',
  'pages.userCards.detail.fees.tdsFee': '3DS Fee',
  'pages.userCards.detail.fees.smallAmountFee': 'Small Amount Fee',
  'pages.userCards.detail.fees.chargebackFee': 'Chargeback Fee',
  'pages.userCards.detail.fees.authFailFee': 'Auth Fail Fee',
  'pages.userCards.detail.fees.crossBorderFee': 'Cross Border Fee',
  'pages.userCards.detail.fees.specialRegionFee': 'Special Region Fee',

  // Recharge Extended
  'pages.userCards.recharge.submit': 'Confirm Recharge',
  'pages.userCards.recharge.amount.max': 'Exceeded maximum recharge limit',
  'pages.userCards.recharge.amount.minValue':
    'Minimum recharge amount is ${min}',
  'pages.userCards.recharge.amount.maxValue':
    'Maximum recharge amount is ${max}',
  'pages.userCards.recharge.limit': 'Recharge Limit',
  'pages.userCards.recharge.failed': 'Recharge failed',
  'pages.userCards.recharge.usdBalance': 'USD Balance',
  'pages.userCards.recharge.insufficientBalance': 'Insufficient USD balance',

  // Fee Preview
  'pages.userCards.feePreview.expectedArrival': 'Expected Arrival',
  'pages.userCards.feePreview.fee': 'Fee',
  'pages.userCards.feePreview.withdrawAmount': 'Withdraw Amount',
  'pages.userCards.feePreview.receive': 'Actual Receive',

  // Copy
  'pages.userCards.copied': '{field} copied',

  // Common
  'pages.common.confirm': 'Confirm',
  'pages.common.cancel': 'Cancel',

  // Card Center Page
  'pages.cardCenter.title': 'Card Center',
  'pages.cardCenter.stats.accountBalance': 'Account Balance',
  'pages.cardCenter.stats.cardBalance': 'Card Balance',
  'pages.cardCenter.stats.platformBalance': 'Platform Balance',
  'pages.cardCenter.stats.digitalBalance': 'Digital Assets',
  'pages.cardCenter.stats.fiatBalance': 'Fiat Assets',
  'pages.cardCenter.stats.totalCards': 'Total Cards',
  'pages.cardCenter.stats.activeCards': 'Active Cards',
  'pages.cardCenter.stats.active': 'Active',
  'pages.cardCenter.stats.total': 'Total',
  'pages.cardCenter.stats.assets': 'Assets',
  'pages.cardCenter.tab.myCards': 'My Cards',
  'pages.cardCenter.tab.platformAssets': 'Platform Assets',
  'pages.cardCenter.tab.digitalAssets': 'Digital Assets',
  'pages.cardCenter.tab.fiatAssets': 'Fiat Assets',
  'pages.cardCenter.tab.cardHolder': 'Card Holders',
  'pages.cardCenter.tab.applications': 'Applications',
  'pages.cardCenter.tab.cardProducts': 'Apply Card',
  'pages.cardCenter.tab.transactions': 'Transactions',
  'pages.cardCenter.clickToDeposit': 'Click to deposit',
  'pages.cardCenter.activeOf': 'active of',
  'pages.cardCenter.cards': 'cards',
  'pages.cardCenter.applyFirst': 'Apply Your First Card',
  'pages.cardCenter.status.realtime': 'Real-time',
  'pages.cardCenter.status.connecting': 'Connecting...',
  'pages.cardCenter.frozen': 'Frozen',

  // Swap
  'pages.swap.title': 'Swap',
  'pages.swap.from': 'From',
  'pages.swap.to': 'To',
  'pages.swap.amount': 'Amount',
  'pages.swap.selectCurrency': 'Select currency',
  'pages.swap.selectFrom': 'Please select source currency',
  'pages.swap.selectTo': 'Please select target currency',
  'pages.swap.enterAmount': 'Enter amount',
  'pages.swap.available': 'Available: {amount}',
  'pages.swap.limit': 'Min: {min}, Max: {max}',
  'pages.swap.minAmount': 'Minimum amount is {min}',
  'pages.swap.maxAmount': 'Maximum amount is {max}',
  'pages.swap.insufficientBalance': 'Insufficient balance',
  'pages.swap.getQuote': 'Get Quote',
  'pages.swap.gettingQuote': 'Getting quote...',
  'pages.swap.refresh': 'Refresh',
  'pages.swap.clickToRefresh': 'Click to refresh quote',
  'pages.swap.confirmSwap': 'Confirm Swap',
  'pages.swap.quoteExpired': 'Quote expired, refreshing...',
  'pages.swap.youWillReceive': 'You will receive',
  'pages.swap.expiresIn': 'Expires in',
  'pages.swap.rate': '1 {from} = {price} {to}',
  'pages.swap.success': 'Swap completed successfully',
  'pages.swap.error.quote': 'Failed to get quote',
  'pages.swap.error.execute': 'Failed to execute swap',
  'pages.swap.noPairReverse': 'Reverse swap pair not available',

  // Internal Transfer
  'pages.transfer.title': 'Internal Transfer',
  'pages.transfer.toUserId': 'Recipient User ID',
  'pages.transfer.toUserId.placeholder': 'Enter recipient user ID',
  'pages.transfer.amount': 'Amount',
  'pages.transfer.available': 'Available: {amount}',
  'pages.transfer.selectCurrency': 'Select currency',
  'pages.transfer.remark': 'Remark (Optional)',
  'pages.transfer.remark.placeholder': 'Enter transfer remark',
  'pages.transfer.insufficientBalance': 'Insufficient balance',
  'pages.transfer.success': 'Transfer successful',
  'pages.transfer.failed': 'Transfer failed',
  'pages.transfer.enterUserId': 'Enter recipient user ID',
  'pages.transfer.enterAmount': 'Enter amount',
  'pages.transfer.confirm': 'Confirm Transfer',

  // Swap Management Page
  'pages.swapManage.title': 'Swap Management',
  'pages.swapManage.binanceBalances': 'Binance Balances',
  'pages.swapManage.refresh': 'Refresh',
  'pages.swapManage.locked': 'Locked',
  'pages.swapManage.clickToLoad': 'Click refresh to load balances',
  'pages.swapManage.noBalances': 'No balances available',
  'pages.swapManage.create': 'Create Pair',
  'pages.swapManage.createTitle': 'Create Trading Pair',
  'pages.swapManage.editTitle': 'Edit Trading Pair',
  'pages.swapManage.column.pair': 'Trading Pair',
  'pages.swapManage.column.feeRate': 'Fee Rate',
  'pages.swapManage.column.minAmount': 'Min Amount',
  'pages.swapManage.column.maxAmount': 'Max Amount',
  'pages.swapManage.column.status': 'Status',
  'pages.swapManage.column.action': 'Actions',
  'pages.swapManage.status.active': 'Active',
  'pages.swapManage.status.inactive': 'Inactive',
  'pages.swapManage.action.edit': 'Edit',
  'pages.swapManage.action.delete': 'Delete',
  'pages.swapManage.deleteConfirm': 'Are you sure to delete this trading pair?',
  'pages.swapManage.form.fromSymbol': 'From Symbol',
  'pages.swapManage.form.toSymbol': 'To Symbol',
  'pages.swapManage.form.feeRate': 'Fee Rate',
  'pages.swapManage.form.feeRateHint': '(e.g. 0.005 = 0.5%)',
  'pages.swapManage.form.minAmount': 'Min Amount',
  'pages.swapManage.form.maxAmount': 'Max Amount',
  'pages.swapManage.form.maxAmountHint': '0 means no limit',
  'pages.swapManage.form.isActive': 'Active',
  'pages.swapManage.form.pair': 'Trading Pair',
  'pages.swapManage.createSuccess': 'Created successfully',
  'pages.swapManage.createFailed': 'Create failed',
  'pages.swapManage.updateSuccess': 'Updated successfully',
  'pages.swapManage.updateFailed': 'Update failed',
  'pages.swapManage.deleteSuccess': 'Deleted successfully',
  'pages.swapManage.deleteFailed': 'Delete failed',
  'pages.swapManage.loadFailed': 'Failed to load data',
  'pages.swapManage.column.enableBinance': 'Binance',
  'pages.swapManage.column.dynamicMax': 'Dynamic Max',
  'pages.swapManage.column.continueOnInsufficient': 'Continue',
  'pages.swapManage.column.buffer': 'Buffer',
  'pages.swapManage.form.binanceConfig': 'Binance Configuration',
  'pages.swapManage.form.enableBinance': 'Enable Binance',
  'pages.swapManage.form.enableBinanceHint':
    'Execute real Binance trades for this pair',
  'pages.swapManage.form.dynamicMaxAmount': 'Dynamic Max Amount',
  'pages.swapManage.form.dynamicMaxAmountHint':
    'Dynamically adjust max amount based on Binance balance',
  'pages.swapManage.form.continueOnInsufficient': 'Continue on Insufficient',
  'pages.swapManage.form.continueOnInsufficientHint':
    'Continue user swap even if Binance balance is insufficient',
  'pages.swapManage.form.bufferAmount': 'Buffer Amount',
  'pages.swapManage.form.bufferAmountHint':
    'Buffer amount in USDT for safety margin',

  // Swap Orders Page
  'pages.swapOrders.title': 'Swap Orders',
  'pages.swapOrders.column.id': 'Order ID',
  'pages.swapOrders.column.userId': 'User ID',
  'pages.swapOrders.column.pair': 'Trading Pair',
  'pages.swapOrders.column.fromAmount': 'From Amount',
  'pages.swapOrders.column.toAmount': 'To Amount',
  'pages.swapOrders.column.feeAmount': 'Fee',
  'pages.swapOrders.column.hedgeType': 'Hedge Type',
  'pages.swapOrders.column.status': 'Status',
  'pages.swapOrders.column.createdAt': 'Created At',
  'pages.swapOrders.column.action': 'Actions',
  'pages.swapOrders.action.detail': 'Detail',
  'pages.swapOrders.status.pending': 'Pending',
  'pages.swapOrders.status.completed': 'Completed',
  'pages.swapOrders.status.failed': 'Failed',
  'pages.swapOrders.status.expired': 'Expired',
  'pages.swapOrders.hedgeType.none': 'None',
  'pages.swapOrders.hedgeType.simulated': 'Simulated',
  'pages.swapOrders.hedgeType.real': 'Real',
  'pages.swapOrders.hedgeType.skipped': 'Skipped',
  'pages.swapOrders.detailTitle': 'Order Detail',
  'pages.swapOrders.detail.basicInfo': 'Basic Information',
  'pages.swapOrders.detail.feeRate': 'Fee Rate',
  'pages.swapOrders.detail.exchangeRate': 'Exchange Rate',
  'pages.swapOrders.detail.updatedAt': 'Updated At',
  'pages.swapOrders.detail.errorMessage': 'Error Message',
  'pages.swapOrders.detail.binanceInfo': 'Binance Trade Information',
  'pages.swapOrders.detail.binanceOrderId': 'Binance Order ID',
  'pages.swapOrders.detail.binanceStatus': 'Binance Status',
  'pages.swapOrders.detail.binanceSymbol': 'Trading Symbol',
  'pages.swapOrders.detail.binanceSide': 'Side',
  'pages.swapOrders.detail.binancePrice': 'Executed Price',
  'pages.swapOrders.detail.binanceExecutedQty': 'Executed Qty',
  'pages.swapOrders.detail.binanceQuoteQty': 'Quote Qty',
  'pages.swapOrders.loadFailed': 'Failed to load data',
  'pages.swapOrders.loadDetailFailed': 'Failed to load order detail',

  // Physical Card - Assign
  'pages.physicalCard.assign.button': 'Assign Card',
  'pages.physicalCard.assign.title': 'Assign Physical Card',
  'pages.physicalCard.assign.hint':
    'Please enter the card number printed on your physical card and select the card holder. This is the first step to activate your card.',
  'pages.physicalCard.assign.selectKyc': 'Select Card Holder',
  'pages.physicalCard.assign.selectKyc.required': 'Please select a card holder',
  'pages.physicalCard.assign.selectKyc.placeholder':
    'Select an approved KYC identity',
  'pages.physicalCard.assign.noKyc': 'No approved KYC identity found',
  'pages.physicalCard.assign.noKyc.desc':
    'Please complete KYC verification first in the "Card Holders" tab.',
  'pages.physicalCard.assign.cardNo': 'Card Number',
  'pages.physicalCard.assign.cardNo.placeholder':
    'Enter the card number on your card',
  'pages.physicalCard.assign.cardNo.required': 'Please enter card number',
  'pages.physicalCard.assign.cardNo.invalid':
    'Card number must be 13-19 digits',
  'pages.physicalCard.assign.submit': 'Submit Assignment',
  'pages.physicalCard.assign.success': 'Card assignment submitted successfully',
  'pages.physicalCard.assign.failed': 'Card assignment failed',

  // Physical Card - Activate
  'pages.physicalCard.activate.button': 'Activate',
  'pages.physicalCard.activate.title': 'Activate Physical Card',
  'pages.physicalCard.activate.hint':
    'Please enter the activation code and set your PIN. The activation code is included with your card package.',
  'pages.physicalCard.activate.activateCode': 'Activation Code',
  'pages.physicalCard.activate.activateCode.placeholder':
    'Enter activation code',
  'pages.physicalCard.activate.activateCode.required':
    'Please enter activation code',
  'pages.physicalCard.activate.pin': 'PIN Code',
  'pages.physicalCard.activate.pin.placeholder': 'Enter 6-digit PIN',
  'pages.physicalCard.activate.pin.required': 'Please enter PIN code',
  'pages.physicalCard.activate.pin.invalid': 'PIN must be 6 digits',
  'pages.physicalCard.activate.submit': 'Activate Card',
  'pages.physicalCard.activate.success':
    'Card activation submitted successfully',
  'pages.physicalCard.activate.failed': 'Card activation failed',

  // Commission Management
  'pages.commissionManage.stats.totalCommissions': 'Total Commissions',
  'pages.commissionManage.stats.pendingAmount': 'Pending Amount',
  'pages.commissionManage.stats.frozenAmount': 'Frozen Amount',
  'pages.commissionManage.stats.claimedAmount': 'Claimed Amount',
  'pages.commissionManage.stats.totalDirectRewards': 'Total Direct Rewards',
  'pages.commissionManage.stats.totalLevelDiff': 'Total Level Diff',
  'pages.commissionManage.stats.totalTeamBonus': 'Total Team Bonus',
  'pages.commissionManage.stats.totalRecords': 'Total Records',
  'pages.commissionManage.stats.level1Count': 'L1 Users',
  'pages.commissionManage.stats.level2Count': 'L2 Users',
  'pages.commissionManage.stats.level3Count': 'L3 Users',

  'pages.commissionManage.config.title': 'Commission Config',
  'pages.commissionManage.config.editTitle': 'Edit Commission Config',
  'pages.commissionManage.config.active': 'Active',
  'pages.commissionManage.config.inactive': 'Inactive',
  'pages.commissionManage.config.directRate': 'Direct Rate',
  'pages.commissionManage.config.level1Rate': 'Level 1 Rate',
  'pages.commissionManage.config.level2Rate': 'Level 2 Rate',
  'pages.commissionManage.config.level3Rate': 'Level 3 Rate',
  'pages.commissionManage.config.teamBonusRate': 'Team Bonus Rate',
  'pages.commissionManage.config.rateRequired': 'Please enter rate',
  'pages.commissionManage.config.rateRange': 'Rate must be between 0-100',
  'pages.commissionManage.config.updateSuccess': 'Config updated successfully',
  'pages.commissionManage.config.updateFailed': 'Failed to update config',

  'pages.commissionManage.configType.card_activated': 'Card Activation',
  'pages.commissionManage.configType.recharge_fee': 'Recharge Fee',

  'pages.commissionManage.records.title': 'Commission Records',
  'pages.commissionManage.column.beneficiaryUid': 'Beneficiary ID',
  'pages.commissionManage.column.triggerUserId': 'Trigger User ID',
  'pages.commissionManage.column.rewardType': 'Reward Type',
  'pages.commissionManage.column.sourceType': 'Source Type',
  'pages.commissionManage.column.amount': 'Amount',
  'pages.commissionManage.column.baseAmount': 'Base Amount',
  'pages.commissionManage.column.rate': 'Rate',
  'pages.commissionManage.column.status': 'Status',
  'pages.commissionManage.column.createdAt': 'Created At',
  'pages.commissionManage.column.action': 'Action',

  'pages.commissionManage.rewardType.direct': 'Direct Reward',
  'pages.commissionManage.rewardType.level_diff': 'Level Diff Reward',
  'pages.commissionManage.rewardType.team_bonus': 'Team Bonus',

  'pages.commissionManage.sourceType.card_activated': 'Card Activated',
  'pages.commissionManage.sourceType.recharge_fee': 'Recharge Fee',
  'pages.commissionManage.sourceType.card_withdrawal': 'Card Withdrawal',

  'pages.commissionManage.status.pending': 'Pending',
  'pages.commissionManage.status.frozen': 'Frozen',
  'pages.commissionManage.status.settled': 'Settled',
  'pages.commissionManage.status.claimed': 'Claimed',
  'pages.commissionManage.status.claiming': 'Claiming',

  'pages.commissionManage.filter.userId': 'User ID',
  'pages.commissionManage.filter.rewardType': 'Reward Type',
  'pages.commissionManage.filter.sourceType': 'Source Type',
  'pages.commissionManage.filter.status': 'Status',

  'pages.commissionManage.action.view': 'View',
  'pages.commissionManage.action.edit': 'Edit',
  'pages.commissionManage.action.search': 'Search',
  'pages.commissionManage.action.refresh': 'Refresh',

  'pages.commissionManage.detail.title': 'Commission Record Detail',
  'pages.commissionManage.detail.frozenReason': 'Frozen Reason',
  'pages.commissionManage.detail.updatedAt': 'Updated At',
  'pages.commissionManage.detail.settledAt': 'Settled At',
  'pages.commissionManage.detail.claimedAt': 'Claimed At',

  // User Commission Info Tab
  'pages.userManage.commission.title': 'Commission',
  'pages.userManage.commission.noData': 'No commission data',
  'pages.userManage.commission.levelInfo': 'Level Info',
  'pages.userManage.commission.setLevel': 'Set Level',
  'pages.userManage.commission.currentLevel': 'Current Level',
  'pages.userManage.commission.activatedCards': 'Activated Cards',
  'pages.userManage.commission.directCount': 'Direct Referrals',
  'pages.userManage.commission.teamCards': 'Team Cards',
  'pages.userManage.commission.notActivated':
    'User not activated. Need to activate at least 1 card to claim rewards',
  'pages.userManage.commission.earningsInfo': 'Earnings Info',
  'pages.userManage.commission.totalEarnings': 'Total Earnings',
  'pages.userManage.commission.pendingEarnings': 'Pending',
  'pages.userManage.commission.frozenEarnings': 'Frozen',
  'pages.userManage.commission.claimedEarnings': 'Claimed',
  'pages.userManage.commission.directEarnings': 'Direct Rewards',
  'pages.userManage.commission.levelDiffEarnings': 'Level Diff Rewards',
  'pages.userManage.commission.teamBonusEarnings': 'Team Bonus',
  'pages.userManage.commission.rateInfo': 'Rate Info',
  'pages.userManage.commission.customRate': 'Custom Rate',
  'pages.userManage.commission.setRate': 'Set Rate',
  'pages.userManage.commission.deleteRate': 'Reset to Default',
  'pages.userManage.commission.deleteRateConfirm':
    'Are you sure to delete custom rate and use global config?',
  'pages.userManage.commission.cardRate': 'Card Activation Rate',
  'pages.userManage.commission.feeRate': 'Recharge Fee Rate',
  'pages.userManage.commission.directRate': 'Direct Rate',
  'pages.userManage.commission.level1Rate': 'Level 1 Rate',
  'pages.userManage.commission.level2Rate': 'Level 2 Rate',
  'pages.userManage.commission.teamBonusRate': 'Team Bonus Rate',
  'pages.userManage.commission.remark': 'Remark',
  'pages.userManage.commission.remarkPlaceholder':
    'e.g., VIP user special rate',
  'pages.userManage.commission.setLevelTitle': 'Set User Level',
  'pages.userManage.commission.setLevelDesc':
    'Manually setting user level will override the system calculated level.',
  'pages.userManage.commission.level1': 'Strategic Partner',
  'pages.userManage.commission.level2': 'Premium Partner',
  'pages.userManage.commission.level3': 'Member',
  'pages.userManage.commission.setRateTitle': 'Set Custom Rate',
  'pages.userManage.commission.setRateDesc':
    "After setting custom rate, this user's commission will be calculated using these rates.",
  'pages.userManage.commission.levelUpdateSuccess':
    'User level updated successfully',
  'pages.userManage.commission.levelUpdateFailed':
    'Failed to update user level',
  'pages.userManage.commission.rateUpdateSuccess': 'Rate updated successfully',
  'pages.userManage.commission.rateUpdateFailed': 'Failed to update rate',
  'pages.userManage.commission.rateDeleteSuccess': 'Restored to global config',
  'pages.userManage.commission.rateDeleteFailed':
    'Failed to delete custom rate',

  // Withdraw Config Management
  'pages.withdrawConfig.title': 'Withdraw Config',
  'pages.withdrawConfig.create': 'Create Config',
  'pages.withdrawConfig.createTitle': 'Create Withdraw Config',
  'pages.withdrawConfig.editTitle': 'Edit Withdraw Config',
  'pages.withdrawConfig.loadFailed': 'Failed to load data',
  'pages.withdrawConfig.createSuccess': 'Created successfully',
  'pages.withdrawConfig.createFailed': 'Failed to create',
  'pages.withdrawConfig.updateSuccess': 'Updated successfully',
  'pages.withdrawConfig.updateFailed': 'Failed to update',
  'pages.withdrawConfig.deleteSuccess': 'Deleted successfully',
  'pages.withdrawConfig.deleteFailed': 'Failed to delete',
  'pages.withdrawConfig.deleteConfirm': 'Are you sure to delete this config?',
  'pages.withdrawConfig.column.currency': 'Currency',
  'pages.withdrawConfig.column.chain': 'Network',
  'pages.withdrawConfig.column.feeType': 'Fee Type',
  'pages.withdrawConfig.column.fee': 'Fee',
  'pages.withdrawConfig.column.minAmount': 'Min Amount',
  'pages.withdrawConfig.column.maxAmount': 'Max Amount',
  'pages.withdrawConfig.column.status': 'Status',
  'pages.withdrawConfig.column.action': 'Actions',
  'pages.withdrawConfig.action.edit': 'Edit',
  'pages.withdrawConfig.action.delete': 'Delete',
  'pages.withdrawConfig.status.enabled': 'Enabled',
  'pages.withdrawConfig.status.disabled': 'Disabled',
  'pages.withdrawConfig.feeType.fixed': 'Fixed',
  'pages.withdrawConfig.feeType.percent': 'Percent',
  'pages.withdrawConfig.form.currency': 'Currency',
  'pages.withdrawConfig.form.chain': 'Network',
  'pages.withdrawConfig.form.isEnabled': 'Enabled',
  'pages.withdrawConfig.form.feeType': 'Fee Type',
  'pages.withdrawConfig.form.feeFixed': 'Fixed Fee Amount',
  'pages.withdrawConfig.form.feeFixedHint': 'Required when fee type is fixed',
  'pages.withdrawConfig.form.feePercent': 'Percent Fee',
  'pages.withdrawConfig.form.feePercentHint':
    'e.g. 0.01 = 1%, required when fee type is percent',
  'pages.withdrawConfig.form.minAmount': 'Min Withdraw Amount',
  'pages.withdrawConfig.form.maxAmount': 'Max Withdraw Amount',

  // User Withdraw Modal
  'pages.withdraw.title': 'Withdraw',
  'pages.withdraw.currency': 'Currency',
  'pages.withdraw.selectCurrency': 'Select currency',
  'pages.withdraw.chain': 'Network',
  'pages.withdraw.selectChain': 'Select network',
  'pages.withdraw.address': 'Withdrawal Address',
  'pages.withdraw.addressPlaceholder': 'Enter withdrawal address',
  'pages.withdraw.addressInvalid': 'Invalid address',
  'pages.withdraw.amount': 'Amount',
  'pages.withdraw.minAmount': 'Minimum amount is {min}',
  'pages.withdraw.maxAmount': 'Maximum amount is {max}',
  'pages.withdraw.insufficientBalance': 'Insufficient balance',
  'pages.withdraw.feeType': 'Fee Type',
  'pages.withdraw.fee': 'Fee',
  'pages.withdraw.limit': 'Limit',
  'pages.withdraw.receive': 'You will receive',
  'pages.withdraw.confirm': 'Confirm Withdrawal',
  'pages.withdraw.success': 'Withdrawal request submitted',
  'pages.withdraw.failed': 'Withdrawal failed',

  // Admin Dashboard
  'pages.dashboard.loadError': 'Failed to load data',
  'pages.dashboard.refresh': 'Refresh',
  'pages.dashboard.sync': 'Sync Data',
  'pages.dashboard.sync.title': 'Sync Operation Data',
  'pages.dashboard.sync.description':
    'Calculate and save statistics to database. Execute this when first use or data changes.',
  'pages.dashboard.sync.dateRange': 'Select Date Range (Optional)',
  'pages.dashboard.sync.startDate': 'Start Date',
  'pages.dashboard.sync.endDate': 'End Date',
  'pages.dashboard.sync.hint':
    'Leave empty to sync from earliest record to yesterday',
  'pages.dashboard.sync.confirm': 'Start Sync',
  'pages.dashboard.sync.cancel': 'Cancel',
  'pages.dashboard.sync.type': 'Sync Type',
  'pages.dashboard.sync.typeWallet': 'Wallet Data',
  'pages.dashboard.sync.typeActivity': 'Activity Stats',
  'pages.dashboard.sync.typeCommission': 'Commission Stats',
  'pages.dashboard.sync.descActivity':
    'Recalculate and save statistics for specified dates. Use when scheduled tasks fail.',
  'pages.dashboard.sync.success': 'Sync successful',
  'pages.dashboard.sync.failed': 'Sync failed',
  'pages.dashboard.noData': 'No data',
  'pages.dashboard.overview.title': 'Overview',
  'pages.dashboard.overview.cumulativeDeposit': 'Cumulative Deposits',
  'pages.dashboard.overview.balance': 'Current Balance',
  'pages.dashboard.overview.todayDeposit': 'Today Deposits',
  'pages.dashboard.overview.todayWithdraw': 'Today Withdrawals',
  'pages.dashboard.overview.todayFee': 'Today Fees',
  'pages.dashboard.overview.details': 'Details',
  'pages.dashboard.fee.withdraw': 'Withdraw Fee',
  'pages.dashboard.fee.card': 'Card Fee',
  'pages.dashboard.fee.swap': 'Swap Fee',
  'pages.dashboard.trend.title': 'Trend Analysis',
  'pages.dashboard.trend.deposit': 'Deposit',
  'pages.dashboard.trend.withdraw': 'Withdraw',
  'pages.dashboard.trend.withdraw_fee': 'Withdraw Fee',
  'pages.dashboard.trend.card_fee': 'Card Fee',
  'pages.dashboard.trend.swap_fee': 'Swap Fee',
  'pages.dashboard.trend.balance': 'Balance',
  'pages.dashboard.trend.day': 'Daily',
  'pages.dashboard.trend.week': 'Weekly',
  'pages.dashboard.trend.month': 'Monthly',
  'pages.dashboard.history.title': 'Historical Data',
  'pages.dashboard.history.totalDeposit': 'Total Deposits',
  'pages.dashboard.history.totalWithdraw': 'Total Withdrawals',
  'pages.dashboard.history.totalFee': 'Total Fees',
  'pages.dashboard.table.date': 'Date',
  'pages.dashboard.table.deposit': 'Deposit',
  'pages.dashboard.table.withdraw': 'Withdraw',
  'pages.dashboard.table.fee': 'Fee',
  'pages.dashboard.table.balance': 'Balance',

  // User Activity
  'pages.dashboard.activity.title': 'User Activity',
  'pages.dashboard.activity.hint':
    'If data is missing, click "Sync Data" in the top right corner',
  'pages.dashboard.activity.days': 'days',
  'pages.dashboard.activity.avgDau': 'Average DAU',
  'pages.dashboard.activity.peakDau': 'Peak DAU',
  'pages.dashboard.activity.users': 'users',
  'pages.dashboard.activity.totalOps': 'Total Operations',
  'pages.dashboard.activity.activeUsers': 'Active Users',
  'pages.dashboard.activity.operations': 'Operations',
  'pages.dashboard.activity.recalc': 'Recalculate',
  'pages.dashboard.activity.recalcTitle': 'Recalculate Statistics',
  'pages.dashboard.activity.recalcDesc':
    'Manually trigger recalculation and save statistics for specified dates. Use this when scheduled tasks fail or to recalculate historical data.',
  'pages.dashboard.activity.recalcType': 'Recalculation Type',
  'pages.dashboard.activity.typeAll': 'All',
  'pages.dashboard.activity.typeActivity': 'Activity Stats',
  'pages.dashboard.activity.typeCommission': 'Commission Stats',
  'pages.dashboard.activity.recalcConfirm': 'Start Recalculation',
  'pages.dashboard.activity.recalcHint': 'Select date range to recalculate',
  'pages.dashboard.activity.selectDate': 'Please select a date',
  'pages.dashboard.activity.recalcSuccess': 'Recalculation successful',
  'pages.dashboard.activity.recalcFailed': 'Recalculation failed',

  // Commission Statistics
  'pages.dashboard.commission.title': 'Commission Statistics',
  'pages.dashboard.commission.totalAmount': 'Total Commission',
  'pages.dashboard.commission.claimedAmount': 'Claimed',
  'pages.dashboard.commission.pendingAmount': 'Pending',
  'pages.dashboard.commission.totalCount': 'Total Count',
  'pages.dashboard.commission.claimedCount': 'Claimed Count',
  'pages.dashboard.commission.pendingCount': 'Pending Count',

  // Operation Logs
  'pages.operationLogs.title': 'Operation Logs',
  'pages.operationLogs.refresh': 'Refresh',
  'pages.operationLogs.loadFailed': 'Failed to load data',
  'pages.operationLogs.detailTitle': 'Log Detail',
  'pages.operationLogs.column.userId': 'User ID',
  'pages.operationLogs.column.ip': 'IP Address',
  'pages.operationLogs.column.method': 'Method',
  'pages.operationLogs.column.path': 'Path',
  'pages.operationLogs.column.operationType': 'Operation Type',
  'pages.operationLogs.column.statusCode': 'Status Code',
  'pages.operationLogs.column.duration': 'Duration',
  'pages.operationLogs.column.isAdmin': 'Is Admin',
  'pages.operationLogs.column.createdAt': 'Created At',
  'pages.operationLogs.column.dateRange': 'Date Range',
  'pages.operationLogs.column.action': 'Actions',
  'pages.operationLogs.action.detail': 'Detail',
  'pages.operationLogs.isAdmin.yes': 'Yes',
  'pages.operationLogs.isAdmin.no': 'No',
  'pages.operationLogs.detail.requestDetail': 'Request Detail',
  'pages.operationLogs.type.login': 'Login',
  'pages.operationLogs.type.bindcard': 'Bind Card',
  'pages.operationLogs.type.bindaddress': 'Bind Address',
  'pages.operationLogs.type.deposit': 'Deposit',
  'pages.operationLogs.type.withdraw': 'Withdraw',
  'pages.operationLogs.type.swap': 'Swap',
  'pages.operationLogs.type.card_apply': 'Card Apply',
  'pages.operationLogs.type.card_bindpayer': 'Bind Payer',
  'pages.operationLogs.type.card_recharge': 'Card Recharge',
  'pages.operationLogs.type.card_activate': 'Card Activate',
  'pages.operationLogs.type.asset_query': 'Asset Query',
  'pages.operationLogs.type.admin_config': 'Admin Config',
  'pages.operationLogs.type.admin_query': 'Admin Query',
  'pages.operationLogs.type.callback': 'Callback',
  'pages.operationLogs.type.other': 'Other',

  // Operation Logs - Tab and Source
  'pages.operationLogs.tab.auth': 'Auth Logs',
  'pages.operationLogs.tab.wallet': 'Wallet Logs',
  'pages.operationLogs.detail.source': 'Log Source',
  'pages.operationLogs.source.auth': 'Auth Service',
  'pages.operationLogs.source.wallet': 'Wallet Service',

  // Operation Logs - Auth Operation Types
  'pages.operationLogs.type.logout': 'Logout',
  'pages.operationLogs.type.register': 'Register',
  'pages.operationLogs.type.pre_login': 'Pre-Login',
  'pages.operationLogs.type.pre_register': 'Pre-Register',
  'pages.operationLogs.type.google_login': 'Google Login',
  'pages.operationLogs.type.send_email_code': 'Send Email Code',
  'pages.operationLogs.type.verify_email': 'Verify Email',
  'pages.operationLogs.type.send_verify_code': 'Send Verification Code',
  'pages.operationLogs.type.verify_code': 'Verify Code',
  'pages.operationLogs.type.change_password': 'Change Password',
  'pages.operationLogs.type.forgot_password': 'Forgot Password',
  'pages.operationLogs.type.reset_password': 'Reset Password',
  'pages.operationLogs.type.refresh_token': 'Refresh Token',
  'pages.operationLogs.type.profile_update': 'Profile Update',
  'pages.operationLogs.type.session_revoke': 'Revoke Session',
  'pages.operationLogs.type.kyc_submit': 'KYC Submit',
  'pages.operationLogs.type.kyc_review': 'KYC Review',
  'pages.operationLogs.type.api_key_create': 'Create API Key',
  'pages.operationLogs.type.api_key_revoke': 'Revoke API Key',
  'pages.operationLogs.type.referral_bind': 'Bind Referral',
  'pages.operationLogs.type.commission_claim': 'Claim Commission',
  'pages.operationLogs.type.admin_action': 'Admin Action',
  'pages.operationLogs.type.query': 'Query',
  'pages.operationLogs.type.action': 'Action',

  // ========== Custody Products ==========
  'pages.custodyProducts.title': 'Custody Products',
  'pages.custodyProducts.stats.totalProducts': 'Total Products',
  'pages.custodyProducts.stats.activeProducts': 'Active Products',
  'pages.custodyProducts.create': 'Create Product',
  'pages.custodyProducts.refresh': 'Refresh',
  'pages.custodyProducts.filter.status': 'Status',
  'pages.custodyProducts.filter.active': 'Active',
  'pages.custodyProducts.filter.inactive': 'Inactive',
  'pages.custodyProducts.search': 'Search',
  'pages.custodyProducts.total': '{total} products',
  'pages.custodyProducts.col.nameZh': 'Name (CN)',
  'pages.custodyProducts.col.nameEn': 'Name (EN)',
  'pages.custodyProducts.col.dailyRate': 'Daily Rate',
  'pages.custodyProducts.col.duration': 'Duration (days)',
  'pages.custodyProducts.col.minAmount': 'Min Amount (USDT)',
  'pages.custodyProducts.col.maxAmount': 'Max Amount',
  'pages.custodyProducts.col.status': 'Status',
  'pages.custodyProducts.col.sortOrder': 'Sort Order',
  'pages.custodyProducts.col.createdAt': 'Created At',
  'pages.custodyProducts.col.actions': 'Actions',
  'pages.custodyProducts.action.edit': 'Edit',
  'pages.custodyProducts.action.activate': 'Activate',
  'pages.custodyProducts.action.deactivate': 'Deactivate',
  'pages.custodyProducts.action.confirmActivate':
    'Are you sure to activate this product?',
  'pages.custodyProducts.action.confirmDeactivate':
    'Are you sure to deactivate this product?',
  'pages.custodyProducts.modal.create': 'Create Product',
  'pages.custodyProducts.modal.edit': 'Edit Product',
  'pages.custodyProducts.form.nameZh': 'Name (Chinese)',
  'pages.custodyProducts.form.nameZh.placeholder': 'Chinese product name',
  'pages.custodyProducts.form.nameZh.required':
    'Please enter Chinese product name',
  'pages.custodyProducts.form.nameEn': 'Name (English)',
  'pages.custodyProducts.form.nameEn.placeholder': 'English product name',
  'pages.custodyProducts.form.nameEn.required':
    'Please enter English product name',
  'pages.custodyProducts.form.descriptionZh': 'Description (Chinese)',
  'pages.custodyProducts.form.descriptionZh.placeholder':
    'Chinese product description',
  'pages.custodyProducts.form.descriptionEn': 'Description (English)',
  'pages.custodyProducts.form.descriptionEn.placeholder':
    'English product description',
  'pages.custodyProducts.form.dailyRate': 'Daily Rate (%)',
  'pages.custodyProducts.form.dailyRate.placeholder': 'e.g. 0.233 for 0.233%',
  'pages.custodyProducts.form.dailyRate.required': 'Please enter daily rate',
  'pages.custodyProducts.form.duration': 'Duration (days)',
  'pages.custodyProducts.form.duration.placeholder': 'e.g. 30',
  'pages.custodyProducts.form.duration.required': 'Please enter duration',
  'pages.custodyProducts.form.minAmount': 'Min Amount (USDT)',
  'pages.custodyProducts.form.minAmount.placeholder': 'e.g. 100',
  'pages.custodyProducts.form.minAmount.required':
    'Please enter minimum amount',
  'pages.custodyProducts.form.maxAmount': 'Max Amount (USDT)',
  'pages.custodyProducts.form.maxAmount.placeholder': 'e.g. 10000',
  'pages.custodyProducts.form.sortOrder': 'Sort Order',
  'pages.custodyProducts.form.sortOrder.placeholder': 'e.g. 0',
  'pages.custodyProducts.msg.createSuccess': 'Product created successfully',
  'pages.custodyProducts.msg.createFail': 'Failed to create product',
  'pages.custodyProducts.msg.updateSuccess': 'Product updated successfully',
  'pages.custodyProducts.msg.updateFail': 'Failed to update product',
  'pages.custodyProducts.msg.activateSuccess': 'Product activated successfully',
  'pages.custodyProducts.msg.deactivateSuccess':
    'Product deactivated successfully',
  'pages.custodyProducts.msg.statusFail': 'Failed to update status',
  'pages.custodyProducts.msg.loadFail': 'Failed to load products',
  'pages.custodyProducts.msg.operationFail': 'Operation failed',

  // ========== Custody Orders ==========
  'pages.custodyOrders.title': 'Custody Orders',
  'pages.custodyOrders.stats.totalOrders': 'Total Orders',
  'pages.custodyOrders.stats.activeOrders': 'Active Orders',
  'pages.custodyOrders.stats.totalInvested': 'Total Invested (USDT)',
  'pages.custodyOrders.stats.totalYieldPaid': 'Total Yield Paid (USDT)',
  'pages.custodyOrders.refresh': 'Refresh',
  'pages.custodyOrders.filter.userId': 'Filter by user ID',
  'pages.custodyOrders.filter.status': 'Status',
  'pages.custodyOrders.filter.active': 'Active',
  'pages.custodyOrders.filter.completed': 'Completed',
  'pages.custodyOrders.filter.cancelled': 'Cancelled',
  'pages.custodyOrders.search': 'Search',
  'pages.custodyOrders.total': '{total} orders',
  'pages.custodyOrders.col.orderId': 'Order ID',
  'pages.custodyOrders.col.userId': 'User ID',
  'pages.custodyOrders.col.walletAddress': 'Wallet Address',
  'pages.custodyOrders.filter.walletAddress': 'Filter by wallet address',
  'pages.custodyOrders.col.productNameZh': 'Product (CN)',
  'pages.custodyOrders.col.productNameEn': 'Product (EN)',
  'pages.custodyOrders.col.amount': 'Amount (USDT)',
  'pages.custodyOrders.col.dailyRate': 'Daily Rate (%)',
  'pages.custodyOrders.col.dailyYield': 'Daily Yield',
  'pages.custodyOrders.col.duration': 'Duration',
  'pages.custodyOrders.col.duration.days': '{val} days',
  'pages.custodyOrders.col.claimed': 'Claimed',
  'pages.custodyOrders.col.totalClaimed': 'Total Claimed',
  'pages.custodyOrders.col.status': 'Status',
  'pages.custodyOrders.col.principalWithdrawn': 'Principal Withdrawn',
  'pages.custodyOrders.col.principalWithdrawn.yes': 'Yes',
  'pages.custodyOrders.col.principalWithdrawn.no': 'No',
  'pages.custodyOrders.col.startAt': 'Start At',
  'pages.custodyOrders.col.expireAt': 'Expire At',
  'pages.custodyOrders.msg.loadFail': 'Failed to load orders',

  // ============ User Details Modal ============
  'pages.userDetails.title': 'User Details',
  'pages.userDetails.wallet': 'Wallet',
  'pages.userDetails.userId': 'User ID',
  'pages.userDetails.totalDeposited': 'Total Deposited',
  'pages.userDetails.totalWithdrawn': 'Total Withdrawn',
  'pages.userDetails.activeCustody': 'Active Custody',
  'pages.userDetails.totalYieldClaimed': 'Yield Claimed',
  'pages.userDetails.tab.deposits': 'Deposits',
  'pages.userDetails.tab.withdrawals': 'Withdrawals',
  'pages.userDetails.tab.custody': 'Custody',
  'pages.userDetails.deposit.orderId': 'Order ID',
  'pages.userDetails.deposit.amount': 'Amount',
  'pages.userDetails.deposit.status': 'Status',
  'pages.userDetails.deposit.txHash': 'Tx Hash',
  'pages.userDetails.deposit.createdAt': 'Created',
  'pages.userDetails.deposit.confirmedAt': 'Confirmed',
  'pages.userDetails.withdrawal.id': 'ID',
  'pages.userDetails.withdrawal.amount': 'Amount',
  'pages.userDetails.withdrawal.status': 'Status',
  'pages.userDetails.withdrawal.txHash': 'Tx Hash',
  'pages.userDetails.withdrawal.remark': 'Remark',
  'pages.userDetails.withdrawal.createdAt': 'Created',
  'pages.userDetails.custody.product': 'Product',
  'pages.userDetails.custody.amount': 'Amount',
  'pages.userDetails.custody.dailyYield': 'Daily Yield',
  'pages.userDetails.custody.claimed': 'Claimed',
  'pages.userDetails.custody.totalClaimed': 'Total Claimed',
  'pages.userDetails.custody.status': 'Status',
  'pages.userDetails.custody.principal': 'Principal',
  'pages.userDetails.custody.withdrawn': 'Withdrawn',
  'pages.userDetails.custody.locked': 'Locked',
  'pages.userDetails.custody.period': 'Period',
  'pages.userDetails.tab.team': 'Team',
  'pages.userDetails.team.drillDown': 'Drill-down',
  'pages.userDetails.team.back': 'Back to parent',
  'pages.userDetails.team.wallet': 'Wallet',
  'pages.userDetails.team.level': 'Level',
  'pages.userDetails.team.depth': 'Depth',
  'pages.userDetails.team.depthValue': 'Lv{val}',
  'pages.userDetails.team.performance': 'Performance',
  'pages.userDetails.team.smallArea': 'Small Area',
  'pages.userDetails.team.earnings': 'Earnings',
  'pages.userDetails.team.directCount': 'Direct',
  'pages.userDetails.team.custody': 'Custody',
  'pages.userDetails.team.yes': 'Yes',
  'pages.userDetails.team.no': 'No',
  'pages.userDetails.team.joinedAt': 'Joined',
  'pages.userDetails.team.teamSize': 'Team Size',
  'pages.userDetails.team.totalPerformance': 'Total Performance',
  'pages.userDetails.team.totalEarnings': 'Total Earnings',
  'pages.userDetails.team.smallAreaPerf': 'Small Area',
  'pages.userDetails.team.directEarnings': 'Direct Earnings',
  'pages.userDetails.team.levelDiffEarnings': 'Level Diff Earnings',
  'pages.userDetails.team.levelDistribution': 'Level Distribution',
  'pages.userDetails.team.searchPlaceholder': 'Search by wallet or user ID',
  'pages.userDetails.team.filterLevel': 'Filter level',
  'pages.userDetails.team.filterDepth': 'Filter depth',
  'pages.userDetails.customLevel': 'Custom Level',
  'pages.userDetails.autoLevel': 'Auto',
  'pages.userDetails.locked': 'Locked',
  'pages.userDetails.levelUpdated': 'Level updated',
  'pages.userDetails.customRate': 'Custom Rate',
  'pages.userDetails.globalRate': 'Global',
  'pages.userDetails.customRateTitle': 'Set Custom Commission Rate',
  'pages.userDetails.levelDiffRate': 'Level-Diff Rate',
  'pages.userDetails.directRate': 'Direct Referral Rate',
  'pages.userDetails.remark': 'Remark',
  'pages.userDetails.referralBinding': 'Referral',
  'pages.userDetails.notBound': 'Not bound',
  'pages.userDetails.unbindReferral': 'Unbind',
  'pages.userDetails.unbindConfirmTitle': 'Unbind Referral',
  'pages.userDetails.unbindConfirmDesc':
    'This will remove the referral relationship and recalculate upline performance. Continue?',
  'pages.userDetails.unbindSuccess': 'Referral unbound successfully',
  'pages.userDetails.confirm': 'Confirm',
  'pages.userDetails.cancel': 'Cancel',

  // ============ Withdrawals ============
  'pages.withdrawals.title': 'Withdrawal Management',
  'pages.withdrawals.refresh': 'Refresh',
  'pages.withdrawals.search': 'Search',
  'pages.withdrawals.exportCsv': 'Export CSV',
  'pages.withdrawals.uploadCsv': 'Upload TX Hash CSV',
  'pages.withdrawals.total': '{total} withdrawals',
  'pages.withdrawals.filter.wallet': 'Filter by wallet address',
  'pages.withdrawals.filter.status': 'Status',
  'pages.withdrawals.filter.pending': 'Pending',
  'pages.withdrawals.filter.approved': 'Approved',
  'pages.withdrawals.filter.rejected': 'Rejected',
  'pages.withdrawals.col.user': 'User',
  'pages.withdrawals.col.wallet': 'Wallet',
  'pages.withdrawals.col.amount': 'Amount (USDT)',
  'pages.withdrawals.col.status': 'Status',
  'pages.withdrawals.col.txHash': 'Tx Hash',
  'pages.withdrawals.col.remark': 'Remark',
  'pages.withdrawals.col.createdAt': 'Created',
  'pages.withdrawals.col.reviewedAt': 'Reviewed',
  'pages.withdrawals.col.action': 'Action',
  'pages.withdrawals.action.approve': 'Approve',
  'pages.withdrawals.action.reject': 'Reject',
  'pages.withdrawals.modal.approve.title': 'Approve Withdrawal',
  'pages.withdrawals.modal.approve.desc':
    'Enter the on-chain transaction hash:',
  'pages.withdrawals.modal.approve.placeholder': '0x...',
  'pages.withdrawals.modal.reject.title': 'Reject Withdrawal',
  'pages.withdrawals.modal.reject.desc': 'Enter the reason for rejection:',
  'pages.withdrawals.modal.reject.placeholder': 'Reason...',
  'pages.withdrawals.msg.approveSuccess': 'Withdrawal approved',
  'pages.withdrawals.msg.approveFail': 'Failed to approve',
  'pages.withdrawals.msg.rejectSuccess': 'Withdrawal rejected',
  'pages.withdrawals.msg.rejectFail': 'Failed to reject',
  'pages.withdrawals.msg.txHashRequired': 'Please enter the transaction hash',
  'pages.withdrawals.msg.remarkRequired': 'Please enter a reason',
  'pages.withdrawals.msg.exportSuccess': 'CSV exported',
  'pages.withdrawals.msg.exportFail': 'Export failed',
  'pages.withdrawals.msg.csvMinRows': 'CSV must have header + at least 1 row',
  'pages.withdrawals.msg.csvNoValid': 'No valid rows found in CSV',
  'pages.withdrawals.msg.batchComplete':
    'Batch complete: {succeeded} approved, {failed} failed',
  'pages.withdrawals.msg.batchFail': 'Batch approve failed',
  'pages.withdrawals.msg.batchWarning': 'Some items failed',
  'pages.withdrawals.msg.loadFail': 'Failed to load withdrawals',

  // ========== Deposit Management ==========
  'pages.deposits.title': 'Deposit Management',
  'pages.deposits.refresh': 'Refresh',
  'pages.deposits.search': 'Search',
  'pages.deposits.filterWallet': 'Filter by wallet address',
  'pages.deposits.filterStatus': 'Status',
  'pages.deposits.total': '{total} deposits',

  'pages.deposits.col.orderId': 'Order ID',
  'pages.deposits.col.wallet': 'Wallet',
  'pages.deposits.col.amount': 'Amount (USDT)',
  'pages.deposits.col.status': 'Status',
  'pages.deposits.col.txHash': 'Tx Hash',
  'pages.deposits.col.confirmations': 'Confirmations',
  'pages.deposits.col.created': 'Created',
  'pages.deposits.col.confirmed': 'Confirmed',
  'pages.deposits.col.action': 'Action',
  'pages.deposits.col.confirmedBy': 'Confirmed By',

  'pages.deposits.status.pending': 'Pending',
  'pages.deposits.status.confirming': 'Confirming',
  'pages.deposits.status.confirmed': 'Confirmed',
  'pages.deposits.status.expired': 'Expired',
  'pages.deposits.status.failed': 'Failed',

  'pages.deposits.action.confirm': 'Manual Confirm',
  'pages.deposits.action.confirmTitle': 'Confirm Deposit Order',
  'pages.deposits.action.confirmContent':
    "Are you sure you want to manually confirm this deposit? This will credit {amount} USDT to the user's balance.",
  'pages.deposits.action.remarkLabel': 'Remark (optional)',
  'pages.deposits.action.remarkPlaceholder':
    'Enter a remark for this manual confirmation',

  'pages.deposits.msg.confirmSuccess': 'Order confirmed successfully',
  'pages.deposits.msg.confirmFail': 'Failed to confirm order',
  'pages.deposits.msg.loadFail': 'Failed to load deposits',

  'pages.deposits.tag.manual': 'Manual',

  'pages.deposits.export': 'Export CSV',
  'pages.deposits.msg.exportSuccess': 'CSV exported successfully',
  'pages.deposits.msg.exportFail': 'Failed to export CSV',
};
